// Keyed by short, stable kebab-case keys (e.g. "forgot-password-title") rather
// than the literal English string — makes entries easy to find/grep later and
// keeps translations intact if the English copy is later reworded. English
// itself still needs real values here (the key is no longer the fallback).
export default {
   "forgot-password-title": "Forgot your password?",
   "forgot-password-description":
      "Enter your email below to receive a verification code and recover your password",
   email: "Email",
   cancel: "Cancel",
   submit: "Submit",
   "menu-section-stakeholders": "Stakeholders",
   "menu-section-setup": "Setup",
   "menu-section-implementation": "Implementation",
   "menu-section-support": "Support",
   "menu-item-experts": "Experts",
   "menu-item-approvers": "Approvers",
   "menu-item-organizations": "Organizations",
   "menu-item-requests": "Requests",
   "menu-item-assessments": "Assessments",
   "menu-item-modules": "Modules",
   "menu-item-targets": "Targets",
   "menu-item-workspaces": "Workspaces",
   "menu-item-tickets": "Tickets",
   "menu-section-organization-management": "Organization Management",
   "menu-section-my-account": "My account",
   "menu-item-profile": "Profile",
   "menu-item-team": "Team",
   "menu-item-help-desk": "Help desk",

   // Generic/reusable — shared across list pages (Experts, Organizations, etc.)
   name: "Name",
   country: "Country",
   "phone-number": "Phone number",
   expertise: "Expertise",
   "disabled-reason": "Disabled Reason",
   "not-applicable": "N/A",
   export: "Export",
   "status-pending": "Pending",
   "status-rejected": "Rejected",
   "status-active": "Active",
   "status-disabled": "Disabled",

   // Experts page (/admin/teams) specific
   "experts-management-title": "Experts",
   "experts-request-tab": "Expert request",
   "experts-approved-tab": "Approved experts",
   "experts-deleted-button": "Deleted experts",
   "experts-status-deactivated": "Deactivated",

   // Filter bars / table filters — reused across Experts, Organizations,
   // Requests, Modules, Targets, Progress Summary, etc.
   "filter-search-label": "Which one are you looking for?",
   "search-placeholder": "Search",
   "search-by-name-placeholder": "Search by name",
   "search-task-by-name-placeholder": "Search a task by its name",
   "search-module-by-name-placeholder": "Search a module by its name",
   "search-workspace-by-name-placeholder": "Search a workspace by its name",
   "search-assessment-by-name-placeholder": "Search an assessment by its name",
   "search-expert-by-name-placeholder": "Search an expert by its name",
   "search-request-by-name-placeholder":
      "Search a request by the name of the requesting organization",
   "search-request-by-email-placeholder":
      "Search a request by the email of the requesting organization",
   "search-request-by-name-or-email-placeholder": "Search by its name or email",
   "search-invoice-by-name-placeholder": "Search an invoice by its name",
   "search-organization-by-name-placeholder": "Search an organization by its name",
   "filter-by-type-placeholder": "Filter by type",
   "filter-by-start-date-placeholder": "Filter by start date",
   "filter-by-end-date-placeholder": "Filter by end date",
   "filter-by-year-placeholder": "Filter by year",
   "filter-tasks-by-assigned-member-placeholder": "Filter tasks by Assigned Member",
   "filter-tasks-by-status-placeholder": "Filter tasks by status",
   "filter-workspace-request-by-status-placeholder": "Filter workspace request by status",
   "filter-workspace-by-country-placeholder": "Filter workspace by country",
   "filter-experts-by-country-placeholder": "Filter experts by country",
   "filter-by-submission-date-placeholder": "Filter by submission date",
   "filter-by-assessments-placeholder": "Filter by assessments",
   "filter-by-assessment-placeholder": "Filter by assessment",
   "filter-by-workspace-placeholder": "Filter by workspace",
   "filter-by-score-placeholder": "Filter by score",
   "filter-by-country-placeholder": "Filter by country",
   "filter-by-operating-countries-placeholder": "Filter by operating countries",
   "filter-by-sectors-placeholder": "Filter by sectors",
   "export-organizations-button": "Export organizations",
   "filter-by-module-placeholder": "Filter by module",
   "filter-by-round-placeholder": "Filter by round",
   "filter-by-section-placeholder": "Filter by section",
   "filter-by-owner-placeholder": "Filter by owner",
   "search-by-its-name-placeholder": "Search by its name",
   "guided-assessment": "Guided Assessment",
   "self-assessment": "Self Assessment",
   "clear-all-button": "Clear all",
   "filters-button": "Filters",
   workspace: "Workspace",
   assessment: "Assessment",
   score: "Score",
   city: "City",
   "operating-countries": "Operating countries",
   sectors: "Sectors",
   type: "Type",
   organizations: "Organizations",
   "select-workspace-placeholder": "Select the workspace",
   "select-assessment-placeholder": "Select the assessment",
   "select-score-range-placeholder": "Select the score range",
   "select-country-placeholder": "Select the country",
   "select-base-city-placeholder": "Select your base city",
   "select-sectors-placeholder": "Select the sectors",
   "select-type-placeholder": "Select the type",

   // Requests (Approved/Pending/Rejected) — /admin/request
   "toast-oops-title": "Oops! A problem has occurred!",
   "toast-request-accepted-success-title": "Request accepted successfully!",
   "toast-request-accepted-success-description":
      "This request was successfully accepted, the response will be notified to the requesting user.",
   "toast-request-accept-error-description":
      "We had a problem accepting this request, please try again.",
   "toast-request-rejected-success-title": "Request rejected successfully!",
   "toast-request-rejected-success-description":
      "This request was successfully rejected, the response will be notified to the requesting user.",
   "toast-request-reject-error-description":
      "We had a problem rejecting this request, please try again.",
   "toast-requests-accepted-success-title": "Requests accepted successfully!",
   "toast-requests-accepted-success-description":
      "The requests were successfully accepted, the response will be notified to the requesting users.",
   "toast-requests-accept-error-description":
      "We had a problem accepting these requests, please try again.",
   "toast-requests-rejected-success-title": "Requests rejected successfully!",
   "toast-requests-rejected-success-description":
      "The requests were successfully rejected, the response will be notified to the requesting users.",
   "toast-requests-reject-error-description":
      "We had a problem rejecting these requests, please try again.",
   "approve-all-button": "Approve all",
   "reject-all-button": "Reject all",

   // Targets filter (/admin/targets)
   "search-target-placeholder": "Search a target by assessment or module name",
   "show-active-rounds-checkbox": "Show active rounds",

   // Progress Summary
   "general-score-column": "General score",
   "submissions-column": "Submissions",
   "tasks-column": "Tasks",
   "areas-complete-text": "areas complete",
   "organizations-progress-summary-title": "Organizations progress summary",
   "export-progress-summary-button": "Export Progress Summary",
   "select-module-performance-label":
      "Select the module to see the performance of the organizations",
   "all-modules-placeholder": "All modules",

   // Requests page tabs, columns, and modals (/admin/request)
   "registration-request-tab": "Registration request",
   "workspace-request-tab": "Workspace request",
   "assessment-request-tab": "Assessment request",
   "status-approved": "Approved",
   "requesting-user-column": "Requesting user",
   "request-date-column": "Request date",
   "approval-date-column": "Approval date",
   "processed-by-column": "Processed by",
   "workspace-name-column": "Workspace name",
   "assessment-name-column": "Assessment name",
   "consultant-name-column": "Consultant name",
   "rejection-date-column": "Rejection date",
   "accept-request-title": "Accept Request",
   "accept-request-button": "Accept request",
   "accept-request-description":
      "You're about to accept this request. This action can't be undone.",
   "reject-request": "Reject request",
   "reject-request-description":
      "You're about to reject this request. This action can't be undone.",
   "confirm-continue-text": "Are you sure you want to continue?",
   "reject-button": "Reject",
   "approve-button": "Approve",
   "organization-request-title": "Organization Request",
   "foundation-label": "Foundation",
   "address-label": "Address",
   "organization-sectors-label": "Organization Sectors",
   "organization-type-label": "Organization Type",
   "organization-size-label": "Organization Size",
   "organization-name-label": "Organization name",
   "organization-description-label": "Organization description",

   // Organizations list (admin)
   "organization-deleted-success-title": "Organization deleted successfully!",
   "organization-deleted-success-description": "This organization was successfully deleted.",
   "organization-delete-error-description":
      "We had a problem deleting this organization, please try again.",
   "organization-restored-success-title": "Organization restored successfully!",
   "organization-restored-success-description": "This organization was successfully restored.",
   "organization-restore-error-description":
      "We had a problem disabling this organization, please try again.",
   "organization-restore-failed-error-description":
      "We had a problem restoring this organization, please try again.",
   "organization-disabled-success-title": "Organization disabled successfully!",
   "organization-disabled-success-description": "This organization was successfully disabled.",
   "disable-organization-title": "Disable organization",
   "disable-organization-description-text":
      "You're about to disable this organization. It will be moved to the disabled list until it's restored.",
   "reason-for-disabling-label": "Reason for disabling",
   "disable-organization-reason-placeholder":
      "Please enter the reason for disabling this organization",
   "disable-button": "Disable",
   "restore-organization-title": "Restore organization",
   "registration-date-column": "Registration Date",
   "organization-list-title": "Organization list",
   "enroll-organizations-button": "Enroll into another workspace",
   "registered-organizations-label": "Registered organizations",
   "average-score-label": "Average score",
   "registered-as-of-text": "Registered as of",
   "social-networks-title": "Social Networks",
   "offices-title": "Offices",
   "ongoing-projects-label": "Ongoing projects",
   "members-label": "Members",
   "representative-label": "Representative",
   "representative-name-label": "Representative name",
   "representative-title-label": "Representative title",
   "representative-location-label": "Representative location",
   "representative-phone-label": "Representative phone",
   "representative-skype-label": "Representative skype",
   "representative-email-label": "Representative email",

   // Organization enroll / delete modals (admin)
   "workspace-required-validation": "Workspace is required",
   "organizations-enrolled-success-title": "Organizations enrolled successfully!",
   "organizations-enrolled-success-description":
      "These organizations were successfully to the workspace you selected.",
   "organizations-enroll-error-description":
      "We had a problem enrolling these organizations, please try again.",
   "enroll-organization-modal-title": "Enroll organization into another workspace",
   "select-workspace-to-enroll-label": "Select the workspace to enroll the organizations",
   "confirm-button": "Confirm",
   "delete-button": "Delete",
   "delete-organization-title": "Delete organization",
   "delete-organization-description":
      "You're about to delete this organization. This action can't be undone.",

   // Edit organization (admin)
   "update-successful-message": "Update is successfull",
   "max-50-symbols-validation": "Maximum 50 symbols",
   "min-3-symbols-validation": "Minimum 3 symbols",
   "invalid-email-validation": "Invalid email",
   "required-validation": "Required",
   "edit-organization-details-title": "Edit organization details",
   "project-number-title": "Project number",
   "ongoing-project-number-label": "Ongoing project number",
   "social-label": "Social",
   "website-label": "Website",
   "facebook-label": "Facebook",
   "twitter-label": "Twitter",
   "linkedin-label": "Linkedin",
   "instagram-label": "Instagram",
   "back-button": "Back",
   "update-button": "Update",

   // Organization details page (workspace + action-plan organization view)
   "representative-removed-success-title": "Representative details removed successfully!",
   "representative-removed-success-description": "Your representative details information was removed.",
   "representative-remove-error-description":
      "We had a problem removing your representative details information, please try again.",
   "profile-status-changed-title": "Your profile status has been changed!",
   "profile-status-changed-description": "Your profile status has been successfully changed.",
   "profile-status-change-error-description":
      "We had a problem with changing the status of profile, please try again.",
   "go-back-to-organizations-link": "Go back to organizations",
   "print-profile-button": "Print profile",
   "make-profile-public-button": "Make profile public",
   "make-profile-private-button": "Make profile private",
   "complete-profile-reminder-title": "Don't forget to complete your profile!",
   "complete-profile-reminder-description":
      "Maximize your visibility within the community through a complete profile and making it public.",
   "complete-profile-now-button": "Complete profile now",
   "profile-status-label": "Profile status",
   "private-status": "Private",
   "public-status": "Public",
   "organization-email-label": "Organization email",
   "base-country-label": "Base country",
   "zip-code-label": "Zip code",
   "about-label": "About",
   "foundation-date-label": "Foundation date",
   "organizations-size-label": "Organizations size",
   "countries-where-operate-label": "Countries where organizations operate",
   "sector-that-works-label": "Sector that organization works",
   "representative-details-title": "Representative details",
   "delete-all-representative-info-button": "Delete all representative info",
   "add-representative-details-button": "Add representative details",
   "no-information-available-text": "No information available",
   "location-label": "Location",
   "edit-representative-details-button": "Edit representative details",
   "assessments-scores-title": "Assessments scores",
   "assessments-scores-description":
      "Check the results of this organization in the completed assessments.",
   "select-self-assessment-placeholder": "Select the self-assessment",
   "no-self-assessment-yet-title": "No self assessment yet",
   "no-self-assessment-yet-description": "This organization hasn't completed a self-assessment yet",
   "select-guided-assessment-placeholder": "Select the guided-assessment",
   "no-guided-assessment-yet-title": "No guided assessment yet",
   "no-guided-assessment-yet-description":
      "This organization hasn't completed a guided assessment yet",
   "team-member-list-title": "Team member list",
   "team-member-list-description":
      "Add your team members and collaborate to strengthen your organization. This section is visible only to you. Even if your profile is public, no one else will be able to see the members you add.",
   "latest-round-label": "Latest round",
   "size-label": "Size",
   "select-number-placeholder": "Select the number",
   "select-date-placeholder": "Select a date",

   // Edit organization profile modal (workspace)
   "profile-updated-success-title": "Profile updated successfully!",
   "profile-updated-success-description": "Your profile information was correctly updated.",
   "profile-update-error-description":
      "We had a problem updating your profile information, please try again.",
   "international-name-required-validation": "International name is required",
   "date-of-establishment-required-validation": "Date of establishment is required",
   "address-required-validation": "Address is required",
   "zip-code-required-validation": "Zip code is required",
   "email-required-validation": "Email is required",
   "invalid-phone-number-validation": "Invalid phone number",
   "phone-number-required-validation": "Phone number is required",
   "at-least-one-sector-required-validation": "At least one sector is required",
   "organization-size-required-validation": "Organization size is required",
   "at-least-one-country-required-validation": "At least one country is required",
   "base-country-required-validation": "Base country is required",
   "city-required-validation": "City is required",
   "edit-profile-title": "Edit Profile",
   "organization-details-tab": "Organization Details",
   "international-name-placeholder": "International name",
   "description-placeholder": "Description",
   "foundation-year-label": "Foundation year",
   "select-organization-size-placeholder": "Select size of organization",
   "countries-where-operates-label": "Countries where organization operates",
   "select-operating-countries-placeholder": "Select operating countries",
   "working-sector-label": "Working sector",
   "select-sectors-alt-placeholder": "Select Sectors",
   "contact-information-tab": "Contact Information",
   "organizations-email-label": "Organization's email",
   "select-base-country-placeholder": "Select base country",
   "select-a-city-placeholder": "Select a city",
   "save-changes-button": "Save changes",

   // Profile information page (account profile edit forms)
   "name-label": "Name",
   "city-label": "City",
   "birthdate-label": "Birthdate",
   "select-your-prefix": "Select your",
   "area-of-expertise-colon-label": "Area of expertise:",
   "years-suffix-label": "years",
   "professional-details-title": "Professional details",
   "enter-current-password-placeholder": "Enter your current password",
   "enter-new-password-placeholder": "Enter your new password",
   "enter-new-password-again-placeholder": "Enter your new password again",
   "enter-your-email-placeholder": "Enter your email",

   // Login information page (LoginInfo.js)
   "account-information-label": "Account information",
   "email-label": "Email",
   "current-password-label": "Current password",
   "new-password-label": "New password",
   "password-hint-intro-text": "In order to protect your account, your password must contain at least:",
   "password-hint-length": "8 characters long",
   "password-hint-uppercase": "One uppercase character",
   "password-hint-lowercase": "One lowercase character",
   "password-hint-number": "One number",
   "password-hint-special": "One special character",
   "change-password-here-text": "You can change your password here",
   "email-changed-success-title": "Email changed successfully!",
   "email-changed-success-description": "Your email was correctly updated.",
   "email-update-error-description": "We had a problem changing your email, please try again.",
   "password-changed-success-title": "Password changed successfully!",
   "password-changed-success-description": "Your password was correctly updated.",
   "password-update-error-description":
      "We had a problem changing your password, please try again.",
   "current-password-required-validation": "Current password is required",
   "new-password-required-validation": "New password is required",
   "confirm-new-password-required-validation": "Confirm new password is required",

   // Account management: deactivate/delete account (LoginInfo.js)
   "account-management-title": "Account management",
   "deactivate-account-title": "Deactivate account",
   "deactivate-account-description":
      "You can deactivate your account here. This will make your account temporarily unusable. However, this action is fully reversible, and",
   "deactivate-account-explanation":
      "you can reactivate your account at any time by simply logging back in.",
   "delete-account-title": "Delete account",
   "delete-account-description":
      "Deleting your account will permanently remove all your data from our system.",
   "delete-account-explanation":
      "This action is irreversible, meaning once your account is deleted, you will not be able to recover any of your information or content.",
   "delete-account-explanation-2": "If you are certain you want to proceed,",
   "delete-account-explanation-3":
      "please be aware that you will lose access to all services and data associated with your account.",
   "delete-account-modal-title": "Delete your account",
   "deactivate-account-modal-title": "Deactivate your account",
   "delete-account-modal-description": "Oh, we're sorry to see you go, but respect your decision!",
   "deactivate-account-modal-description":
      "Thinking of taking a break? Deactivating your account is always an option.",
   "confirm-account-deletion-title": "Confirm account deletion",
   "confirm-account-deactivation-title": "Confirm account deactivation",
   "confirm-delete-account-description":
      "You're about to permanently delete your account and data.",
   "confirm-deactivate-account-description": "You're about to deactivate your account.",
   "confirm-action-other-desc": "Are you sure you want to continue?",
   "delete-reason-1": "I no longer need the service.",
   "delete-reason-2": "I found another service that fits my needs better.",
   "delete-reason-3": "I had a bad experience.",
   "delete-reason-4": "I'm concerned about my data privacy.",
   "deactivate-reason-1": "I need a short break.",
   "deactivate-reason-2": "I'm currently too busy to use the platform.",
   "deactivate-reason-3": "I'm dealing with personal matters.",
   "deactivate-reason-4": "I want to focus on other priorities for now.",
   "other-please-specify-label": "Other (please specify)",
   "enter-your-answer-placeholder": "Enter your answer here",
   "delete-account-feedback-prompt":
      "We'd love to hear your thoughts. Could you share why you're considering deleting your account?",
   "deactivate-account-feedback-prompt":
      "We'd love to hear your thoughts. Could you share why you're considering deactivating your account?",
   "delete-account-followup-question":
      "Thank you for being with us. Is there anything we could have done to make your experience even better?",
   "deactivate-account-followup-question":
      "We're always looking to improve. If you have any suggestions or comments, we'd appreciate hearing them",
   "delete-account-error-description": "We had a problem deleting your account, please try again.",
   "deactivate-account-error-description":
      "We had a problem deactivating your account, please try again.",

   // Payment information page (PaymentInfo.js, SuccessPaymentInfo.js, FailedPaymentInfo.js)
   "choose-perfect-plan-title": "Choose the perfect plan for you",
   "billed-annually-text": "Billed annually",
   "workspaces-suffix-label": "workspaces",
   "members-suffix-label": "members",
   "data-storage-limit-suffix-label": "data storage limit",
   "see-all-plan-details-link": "See all plan details",
   "plan-selected-label": "Plan selected",
   "select-this-plan-button": "Select this plan",
   "view-billing-portal-button": "View billing portal",
   "checkout-button": "Checkout",
   "active-subscription-error-description":
      "User already has an active subscription. Please choose a different plan.",
   "payment-billing-error-description": "We had a problem billing this payment, please try again.",
   "purchase-successful-title": "Purchase successful!",
   "payment-processed-success-text": "Your payment has been successfully processed.",
   "thank-you-for-purchase-text": "Thank you for your purchase!",
   "go-back-to-payment-info-text": "Go back to payment information",
   "purchase-failed-title": "Purchase failed",
   "purchase-failed-description":
      "Unfortunately, your recent purchase attempt was not successful. There may have been an issue with payment processing or a problem with the information provided. Please check your payment details and try again.",
   "apologize-inconvenience-text": "We apologize for the inconvenience and appreciate your patience.",

   // Profile edit form validation messages (validationSchema.js)
   "min-3-symbols-validation": "Minimum 3 symbols",
   "max-50-symbols-validation": "Maximum 50 symbols",
   "invalid-organization-email-validation": "Invalid organization email",
   "organization-address-required-validation": "Organization address is required",
   "operating-countries-required-validation": "Operating countries is required",

   // Account deleted/deactivated confirmation page (AccountDeletedORDeactivated.js)
   "account-action-icon-alt": "account action",
   "account-deactivated-notice-text": "Your account has been successfully deactivated at your request.",
   "account-deleted-notice-text": "Your account has been successfully deleted at your request.",
   "positive-experience-farewell-text":
      "We trust you've had a positive experience with us, and we want you to know that you'll always be welcomed back whenever you choose to return.",
   "kaporg-best-regards-text": "Best regards, KAPorg team.",

   // Edit profile picture modal (EditProfilePicture.js)
   "edit-profile-picture-title": "Edit profile picture",
   "change-profile-picture-button": "Change profile picture",
   "delete-profile-picture-button": "Delete profile picture",
   "profile-picture-updated-success-title": "Profile picture updated successfully!",
   "profile-picture-updated-success-description": "Your profile picture was correctly updated.",
   "profile-picture-update-error-description":
      "We had a problem updating your profile picture, please try again.",
   "profile-picture-deleted-success-title": "Profile picture deleted successfully!",
   "profile-picture-deleted-success-description": "Your profile picture has been deleted.",
   "profile-picture-delete-error-description":
      "We had a problem deleting your profile picture, please try again.",

   // Add member / change status / delete member modals (workspace)
   "name-required-validation": "Name is required",
   "gender-required-validation": "Gender is required",
   "role-required-validation": "Role is required",
   "team-member-added-success-title": "Team member added successfully!",
   "team-member-added-success-description": "This member was successfully added to your team database.",
   "team-member-add-error-description":
      "We had a problem adding this member to your team database, please try again.",
   "add-new-member-title": "Add new member",
   "gender-label": "Gender",
   "select-gender-placeholder": "Select Gender",
   "role-label": "Role",
   "select-role-placeholder": "Select role",
   "make-my-profile-public-button": "Make my profile public",
   "make-my-profile-private-button": "Make my profile private",
   "make-profile-public-title": "Make profile public",
   "make-profile-private-title": "Make profile private",
   "profile-visibility-notice-public":
      "By making your public national organizations, donors, and experts will be able to see your information and results. Therefore, we recommend ensuring all your information is complete before making it public.",
   "profile-visibility-notice-private":
      "By making your private national organizations, donors, and experts will be able to see your information and results. Therefore, we recommend ensuring all your information is complete before making it private.",
   "delete-member-title": "Delete member",
   "delete-member-description": "You're about to delete this member. This action can't be undone.",
   "delete-all-representative-details-title": "Delete all representative details",
   "delete-representative-info-description-1":
      "You are about to delete all your representative's information.",
   "delete-representative-info-description-2": "You can add it again later if you wish.",
   "delete-representative-info-description-3":
      "Remember, having a complete profile is crucial for better visibility and opportunities for contact within the community.",
   "organizations-management-title": "Organizations management",

   "representative-updated-success-title": "Representative details updated successfully!",
   "representative-updated-success-description":
      "Your representative details information was correctly updated.",
   "representative-update-error-description":
      "We had a problem updating your representative details information, please try again.",
   "edit-representative-detail-title": "Edit representative detail",
   "full-name-label": "Full Name",
   "phone-label": "Phone",
   "edit-representative-button": "Edit representative",
   "representative-added-success-title": "Representative details was added successfully!",
   "representative-added-success-description":
      "Your representative details information was correctly added.",
   "representative-add-error-description":
      "We had a problem adding your representative details information, please try again.",
   "create-representative-detail-title": "Create a new representative detail",

   "team-member-removed-success-title": "Team member removed successfully!",
   "team-member-removed-success-description":
      "This member was successfully removed to your team database.",
   "team-member-remove-error-description":
      "We had a problem removing this member from your team database, please try again.",
   "fullname-column": "Fullname",
   "member-search-label": "Which member are you looking for?",
   "search-member-by-name-placeholder": "Search a member by its name",
   "add-member-button": "Add member",
   "new-member-button": "New member",
   "birthdate-label": "Birthdate",
   "email-field-label": "Email",
   "name": "Name",
   "email": "Email",
   "cancel": "Cancel",
   "no-assessments-listed-text": "No assessments listed",
   "remaining-months-days-text": "{months} months, {days} days",
   "more-actions-label": "More actions",
   "sort-ascending-alt": "Sort ascending",
   "sort-descending-alt": "Sort descending",
   "error-unauthorized-text": "Sorry, you are not authorized to access this page.",
   "error-page-not-found-text": "Sorry, the page you visited does not exist.",
   "error-oops-title": "Oops...",
   "back-home-button": "Back home",
   "error-something-wrong-text": "Looks like something went wrong. We're working on it",

   // Requests management (admin)
   "requests-management-title": "Requests management",

   // Assessment management (admin)
   "archived-assessments-link": "Archived assessments",
   "deleted-assessments-link": "Deleted assessments",
   "add-new-assessment-button": "New assessment",
   "assessment-list-title": "Assessments",
   "archive-button": "Archive",
   "archive-assessment-title": "Archive assessment",
   "delete-assessment-title": "Delete assessment",
   "archive-assessment-description": "You're about to archive this assessment.",
   "delete-assessment-description": "You're about to delete this assessment.",

   // Add assessment (admin)
   "start-date-after-previous-end-validation": "Start date should be greater than previous end date",
   "end-date-after-start-validation": "End date should be greater than start date",
   "assessment-name-empty-validation": "Assessment name cannot be empty",
   "submission-round-label-empty-validation": "Submission round label cannot be empty",
   "date-fields-required-validation": "Date fields are required",
   "start-date-required-validation": "Start date is required",
   "end-date-required-validation": "End date is required",
   "assessment-created-success-title": "Assessment created successfully!",
   "assessment-created-success-description":
      "A new assessment has been created and added to your database.",
   "assessment-create-error-description":
      "We had a problem creating this assessment, please try again.",
   "assessment-details-title": "Assessment details",
   "assessment-name-label": "Assessment name",
   "enter-assessment-name-placeholder": "Enter the assessment name",
   "assessment-type-label": "Assessment type",
   "submission-round-label-field": "Submission round label",
   "enter-submission-round-placeholder": "Enter the submission round",
   "start-date-label": "Start date",
   "end-date-label": "End date",
   "add-new-submission-round-button": "Add new submission round",
   "dynamic-range-label": "Dynamic range",
   "select-score-range-description":
      "Select the range for your assessment's score variables (up to 5)",
   "score-variables-label": "score variables",
   "from-label": "From",
   "to-label": "to",
   "score-label-field": "Score label",
   "score-description-field": "Score description",
   "enter-label-description-placeholder": "Enter a description of the label",
   "add-assessment-button": "Add assessment",
   "assessment-assigned-success-title": "Assessment assigned successfully!",
   "assessment-assigned-success-description":
      "This assessment has been successfully assigned to your team members. They will be notified about this action.",
   "assessment-assign-error-description":
      "We had a problem assigning this assessment to your team members, please try again.",
   "assign-assessment-to-team-title": "Assign assessment to team",
   "project-management-label": "Project management",

   // Edit assessment / assign module (admin)
   "assessment-updated-success-title": "Assessment updated successfully!",
   "assessment-updated-success-description": "This assessment was updated correctly.",
   "assessment-update-error-description":
      "We had a problem updating this assessment, please try again.",
   "edit-assessment-title": "Edit assessment",
   "edit-assessment-of-team-title": "Edit assessment of this team",
   "select-project-management-placeholder": "Select project management",
   "module-assigned-success-title": "Module assigned successfully!",
   "module-assigned-success-description":
      "This module has been successfully assigned to your staff members. They will be notified about this action.",
   "module-unassigned-success-title": "Module unassigned successfully!",
   "module-unassigned-success-description":
      "This module has been successfully unassigned by staff member.",
   "module-assign-error-description":
      "We had a problem assigning this module to your staff members, please try again.",
   "assign-module-to-members-title": "Assign module to members",
   "module-name-label": "Module name",
   "members-to-assign-label": "Members to assign this module to",
   "unassign-button": "Unassign",
   "assign-module-button": "Assign Module",
   "member-required-validation": "Member is required",

   // Duplicate/unlink assessment comparison + guided request expert modal (admin)
   "comparison-created-success-title": "New comparison version created!",
   "comparison-created-success-description":
      "The new comparison version was created successfully and it's ready to review.",
   "comparison-create-error-description":
      "We had a problem creating this comparison version, please try again.",
   "duplicate-for-comparison-title": "Duplicate for comparison",
   "duplicate-comparison-description-1":
      "This will create a copy of the assessment and link both versions for result comparison.",
   "duplicate-comparison-description-2":
      "Once duplicated, the assessments and any associated modules can't be modified.",
   "current-assessment-label": "Current assessment",
   "new-comparison-version-label": "New comparison version",
   "comparison-suffix-label": "Comparison",
   "duplicate-comparison-note":
      "Note: If needed, you can remove the link later to edit them independently, but the comparison won't be available anymore.",
   "duplicate-button": "Duplicate",
   "assessments-unlinked-success-title": "Assessments unlinked!",
   "assessments-unlinked-success-description":
      "The assessments were successfully unlinked and can now be edited independently.",
   "assessments-unlink-error-description":
      "We had a problem unlinking the assessments, please try again.",
   "unlink-assessments-title": "Unlink these assessments?",
   "unlink-assessments-description":
      "They will no longer be connected for comparison, and the comparison view will no longer be available.",
   "original-assessment-label": "Original Assessment",
   "duplicated-assessment-label": "Duplicated Assessment",
   "unlink-assessments-note": "Note: After unlinking them, each assessment can be edited independently.",
   "unlink-button": "Unlink",
   "expert-name-column": "Expert name",
   "years-of-experience-column": "Years of experience",
   "expert-cv-column": "Expert CV",
   "cv-link-text": "CV Link",
   "no-cv-available-text": "No CV Available",
   "areas-of-expertise-column": "Areas of expertise",
   "select-expert-request-access-title": "Select an expert and request access",
   "first-choose-expert-subtitle": "Firts choose an expert",
   "choose-expert-guide-hint": "Choose an expert to guide your assessment",
   "request-access-button": "Request access",
   "go-back-experts-list-link": "Go back to experts list",
   "no-description-available-text": "No description available",
   "no-expertise-listed-text": "No expertise listed",
   "nationality-label": "Nationality",
   "no-nationality-listed-text": "No nationality listed",
   "country-of-residence-label": "Country of residence",
   "no-country-of-residence-text": "No country of residence",
   "no-operating-countries-listed-text": "No operating countries listed",
   "linkedin-profile-label": "LinkedIn profile",
   "no-linkedin-profile-text": "No LinkedIn profile provided",
   "no-phone-number-listed-text": "No phone number listed",
   "highest-degree-label": "Highest degree obtained",
   "no-highest-degree-listed-text": "No highest degree obtained listed",
   "fields-of-study-label": "Fields of study",
   "no-study-fields-listed-text": "No study fields listed",
   "educational-institution-label": "Educational institution",
   "no-educational-institution-listed-text": "No educational institution listed",
   "languages-label": "Languages",
   "no-languages-listed-text": "No languages listed",
   "cv-label": "CV",
   "no-cv-listed-text": "No CV listed",
   "certification-training-label": "Certification or a special training",
   "no-certification-listed-text": "No certification or a special training listed",

   // Archived/deleted assessments (admin)
   "archived-assessments-list-title": "Archived Assessments list",
   "deleted-assessments-title": "Deleted Assessments",
   "delete-permanently-button": "Delete permanently",
   "unarchive-assessments-button": "Unarchive assessments",
   "restore-assessments-button": "Restore assessments",
   "deleted-assessments-description":
      "Here you can view and restore deleted assessments. Any assessment that has not been restored within 60 days will be permanently deleted.",
   "delete-assessment-permanently-title": "Delete assessment permanently",
   "delete-assessments-permanently-title": "Delete assessments permanently",
   "delete-selected-assessment-permanently-description":
      "You're about to delete the selected assessment permanently.",
   "delete-selected-assessments-permanently-description":
      "You're about to delete the selected assessments permanently.",
   "action-cannot-be-undone-confirm-text":
      "This action can't be undone. Are you sure you want to continue?",

   // Guided assessment request (workspace/admin shared)
   "request-sent-success-title": "Request sent successfully!",
   "request-sent-success-description":
      "Your request was sent to the admin. As soon as the request is answered you will receive an email with the response.",
   "request-send-error-description": "We had a problem sending your request, please try again.",
   "request-rejected-title": "Oh no! It seems that your request was rejected",
   "request-rejected-description-line1":
      "For now you can't access to this assessment because your request was rejected.",
   "request-rejected-description-line2": "But don't worry! You can request access again.",
   "request-pending-title": "You already request access for this assessment!",
   "request-pending-description-line1":
      "Your request was send to the admin of this assessment. As soon as the request is answered you will receive an email with the response.",
   "request-pending-description-line2": "We will get in touch with you as soon as possible.",
   "request-access-title": "Request access for this assessment",
   "request-access-description-part1": "Unlock this guided assessment so",
   "request-access-description-part2": "we can assign our experts",
   "request-access-description-part3": "from your field of work to",
   "request-access-description-part4": "directly support you along the assessment process",
   "request-access-description-part5":
      "and help you explore ways to build better partnerships and secure funding for future programs.",

   // Guided assessments table (admin)
   "guided-assessments-title": "Guided Assessments",
   "assessments-list-title": "Assessments list",
   "organizations-name-column": "Organization's name",
   "assessment-column": "Assessment",
   "status-column": "Status",
   "not-started-status": "Not started",
   "in-progress-status": "In progress",
   "completed-status": "Completed",

   // Consultant guided assessment / self-assessment survey view (admin)
   "success-title": "Success",
   "module-submitted-success-description": "Module submitted successfully",
   "no-submission-rounds-text": "No submission rounds",
   "submission-rounds-title": "Submission rounds",
   "round-target-label": "Target",
   "module-submitted-modal-title": "You successfully submitted this module!",
   "next-round-active-description":
      "Please come back to this assessment when the next submission round is active.",
   "remaining-time-current-round-label": "Remaining time of the current round",
   "start-label": "Start",
   "end-label": "End",
   "linked-modules-title": "Linked modules",
   "no-linked-modules-text": "No linked modules",
   "finished-status": "Finished",
   "completed-text": "completed",

   // Self-assessment survey view (admin)
   "assigned-to-label": "Assigned to",
   "assign-member-button": "Assign member",
   "submitted-at-label": "Submitted at",
   "edit-assignment-button": "Edit Assignment",
   "assign-to-team-button": "Assign to team",
   "assessment-assigned-to-label": "Assessment assigned to:",
   "expert-modules-description":
      "These are the modules that the expert you selected will respond to. Once the expert submits the modules, you will be able to view the results and answers in the Results section.",

   "no-self-assessments-yet-title":
      "It seems that this workspace doesn't have self assessments yet!",
   "no-guided-assessments-yet-title":
      "It seems that this workspace doesn't have guided assessments yet!",
   "work-on-guided-assessments-instead-description":
      "But don't worry, you can work on the guided assessments instead.",
   "work-on-self-assessments-instead-description":
      "But don't worry, you can work on the self assessments instead.",

   // Assessments table columns (admin)
   "name-column": "Name",
   "type-column": "Type",
   "created-by-column": "Created by",
   "created-date-column": "Created date",
   "edit-action": "Edit",
   "founded-label": "Founded",
   "areas-label": "areas",
   "staff-label": "staff",
   "contact-label": "Contact",
   "online-label": "Online",
   "unlink-assessment-action": "Unlink Assessment",
   "edit-assessment-alt": "Edit assessment",
   "archive-assessment-alt": "Archive assessment",
   "delete-assessment-alt": "Delete assessment",
   "unlink-assessment-alt": "Unlink assessment",

   // Archived/deleted assessments hook (admin)
   "assessment-deleted-success-title": "Assessment deleted successfully!",
   "assessment-deleted-success-description":
      "This assessment has been successfully deleted from your database.",
   "assessment-delete-error-description":
      "We had a problem deleting this assessment, please try again.",
   "assessments-deleted-success-title": "Assessments deleted successfully!",
   "assessments-deleted-success-description":
      "These assessments have been successfully deleted from your database.",
   "assessments-delete-error-description":
      "We had a problem deleting these assessments, please try again.",
   "assessment-restored-success-title": "Assessment restored successfully!",
   "assessment-restored-success-description": "This assessment has been successfully restored.",
   "assessment-unarchive-error-description":
      "We had a problem unarchiving this assessment, please try again.",
   "assessments-unarchived-success-title": "Assessments unarchived successfully!",
   "assessments-unarchived-success-description":
      "These assessments have been successfully unarchived.",
   "assessments-unarchive-error-description":
      "We had a problem unarchiving these assessments, please try again.",
   "assessment-archived-success-title": "Assessment archived successfully!",
   "assessment-archived-success-description": "This assessment was successfully archived.",
   "assessment-archive-error-description":
      "We had a problem adding this assessment to archive, please try again.",
   "assessment-trashed-success-title": "Assessment has been added to the trash bin successfully!",
   "assessment-trashed-success-description":
      "This assessment was successfully added to the trash bin.",
   "assessment-trash-error-description":
      "We had a problem adding this assessment to trash bin, please try again.",

   // Assessment modules per organization (workspace)
   "assessment-modules-title": "Assessment Modules",
   "module-name-column": "Module Name",
   "go-to-module-button": "Go to Module",

   // Consultant organization list (workspace)
   "consultant-organization-list-title": "Consultant Organization list",
   "country-column": "Country",
   "progress-column": "Progress",
   "submitted-status": "Submitted",
   "go-to-assessment-button": "Go to assessment",

   // Survey submission (workspace)
   "module-submitted-toast": "Module is successfully submitted.",
   "no-permission-submit-module-warning": "You don't have permission to submit a module!",
   "submit-button": "Submit",
   "module-submitted-text": "This module is submitted.",

   // Consultant list / consultant selection (workspace)
   "choose-consultant-guide-title": "Choose a consultant to guide your assessment",
   "consultant-profile-title": "Consultant Profile",
   "consultant-label": "Consultant",
   "experience-title": "Experience",
   "education-title": "Education",
   "school-label": "School",
   "skills-title": "Skills",
   "select-this-consultant-button": "Select this Consultant",
   "enrolled-guided-assessment-success-title":
      "You have been successfully enrolled in the guided assessment!",
   "consultant-contact-soon-description-part1": "The consultant",
   "consultant-contact-soon-description-part2":
      "will get in touch with you soon to start your assessments.",
   "go-to-assessments-button": "Go to assessments",

   // Request guided-assessment modal (workspace)
   "improve-score-help-title":
      "Should you wish to improve your score and further grow your organization, the KAPorg team is here to help!",
   "request-guided-assessment-description-part1":
      "Request a guided assessment now so we can assign our experts from your field of work to directly support you along the assessment process and help you explore ways to build better partnerships and secure funding for future programs.",
   "request-guided-assessment-description-part2":
      "Request it now and we will get in touch with you as soon as possible.",
   "request-assessment-code-button": "Request an assessment code",
   "have-assessment-code-button": "I have an assessment code",
   "assessment-code-title": "Assessment code",
   "enter-assessment-code-description":
      "To access your assessment, please type your assessment code below",
   "enter-code-here-label": "Enter your code here",
   "please-enter-code-error": "Please enter code",
   "assessment-list-label": "Assessment list",
   "select-an-assessment-placeholder": "-Select an assessment-",
   "select-assessment-error": "You should select an assessment",
   "submit-request-button": "Submit request",
   "request-assessment-code-title": "Request Assessment Code",
   "request-assessment-code-description":
      "Please request your assessment and we will get in touch with you. As soon as the request is accepted you will receive an email with the code.",
   "select-assessment-from-list-description": "Select an assessment from the list below",
   "code-valid-select-consultant-toast": "Your code was valid and now you can select the consultant",

   // Survey (module) management tabs (admin)
   "my-modules-tab": "My modules",
   "template-library-tab": "Template library",

   // Modules list (admin/survey)
   "module-deleted-success-title": "Module deleted successfully!",
   "module-deleted-success-description": "This module was successfully removed from your database.",
   "module-delete-error-description": "We had a problem deleting this module, please try again.",
   "module-cannot-be-deleted-error": "Module cannot be deleted",
   "preview-action": "Preview",
   "download-action": "Download",
   "turn-into-template-action": "Turn into template",
   "preview-template-alt": "Preview template",
   "edit-module-alt": "Edit module",
   "download-module-alt": "Download module",
   "turn-into-template-alt": "Turn into template",
   "delete-module-alt": "Delete module",
   "title-column": "Title",
   "deleted-modules-button": "Deleted modules",
   "add-module-button": "New module",
   "add-module-modal-button": "Add module",
   "add-new-module-title": "Add new module",
   "add-new-assessment-title": "Add new assessment",
   "survey-status-editing": "Editing",
   "survey-status-archived": "Archived",
   "survey-status-deployed": "Deployed",
   "survey-status-locked": "Locked",

   // Add module modal (admin/survey)
   "how-start-title": "How would you like to start?",
   "create-form-title": "Create form",
   "create-form-description":
      "Start with an empty structure, adding sections and questions as you go.",
   "import-form-title": "Import form",
   "import-form-description": "Upload a file with predefined sections and questions.",
   "use-template-title": "Use a template",
   "use-template-description":
      "Start with a form already stored in the system and easily adjust it to your needs.",
   "continue-button": "Continue",

   // Edit module modal (admin/survey)
   "module-details-title": "Module Details",
   "enter-module-name-placeholder": "Enter the module name",
   "enter-module-description-placeholder": "Enter module description",
   "default-language-label": "Default language",
   "select-default-language-module-placeholder": "Select the default language of the module",
   "select-assessment-label": "Select Assessment",
   "select-assessment-module-placeholder": "Select the assessment of the module",

   // Delete survey/template modal (admin/survey)
   "delete-module-title": "Delete module",
   "delete-template-title": "Delete template",
   "delete-module-confirm-description": "You're about to delete this module. This action can't be undone.",
   "delete-template-confirm-description":
      "You're about to delete this template. This action can't be undone.",

   // Deleted modules modal (admin/survey)
   "module-restored-success-title": "Module restored successfully!",
   "module-restored-success-description": "This module has been successfully restored.",
   "module-restore-error-description": "We had a problem restoring this module, please try again.",
   "deleted-modules-list-title": "Deleted modules list",
   "restore-modules-button": "Restore modules",
   "deleted-modules-description":
      "Here you can view and restore deleted modules. Any modules that has not been restored within 60 days will be permanently deleted.",

   // Import module modal (admin/survey)
   "module-name-required-validation": "Module name is required",
   "upload-module-file-label": "Upload module file",
   "drag-drop-file-text": "Drag and drop file here, or",
   "click-to-select-file-text": "click to select file",
   "max-file-size-text": "Max file size: 20MB",

   // Add module (create from scratch) page (admin/survey)
   "module-create-error-description": "We had a problem creating this module, please try again.",
   "make-module-template-label": "Make this module a template",

   // Import module page (admin/survey)
   "not-a-xlsx-file-error": "is not a xlsx file",
   "upload-valid-xlsx-error": "Please upload a valid xlsx file before submitting.",
   "error-title": "Error",
   "survey-imported-success-description": "Survey Imported Successfully",
   "survey-import-failed-error": "Failed to import the survey.",
   "copy-file-name-tooltip": "Copy File Name",
   "copied-tooltip": "Copied!",
   "module-must-have-right-format-text":
      "Your module must have the right format to import it correctly.",
   "download-format-link": "Download format",
   "enter-description-placeholder": "Enter description",

   // Use survey template page (admin/survey)
   "min-3-characters-validation": "Minimum 3 characters",
   "language-required-validation": "Language is required",
   "assessment-required-validation": "Assessment is required",
   "new-module-suffix": "New Module",

   // Edit survey (legacy) page (admin/survey)
   "edit-module-title": "Edit module",
   "module-description-label": "Module description",

   // Templates list (admin/survey)
   "template-deleted-success-title": "Template deleted successfully!",
   "template-deleted-success-description":
      "This template was successfully removed from your database.",
   "template-delete-error-description":
      "We had a problem deleting this template, please try again.",
   "edit-template-alt": "Edit template",
   "download-template-alt": "Download template",
   "duplicate-template-alt": "Duplicate template",
   "delete-template-alt": "Delete template",
   "copy-action": "Copy",
   "module-title-column": "Module title",
   "created-on-column": "Created on",
   "last-updated-column": "Last updated",

   // Duplicate/copy template modal (admin/survey)
   "copy-suffix-label": "Copy",
   "template-duplicated-success-title": "Template duplicated successfully!",
   "template-duplicated-success-description":
      "Your template has been successfully duplicated. You can now edit and customize the new copy.",
   "template-duplicate-error-description":
      "We had a problem duplicating this template, please try again.",
   "copy-template-title": "Copy template",
   "copy-template-description":
      "You're about to create a reusable template based on this module's structure. You'll be able to use this template to quickly create new modules.",
   "template-name-label": "Template name",
   "template-name-required-validation": "Template name is required",
   "enter-template-name-placeholder": "Enter template name",
   "description-optional-label": "(optional)",
   "template-description-hint-placeholder":
      "A short note to help your team understand when to use this template",

   // Template selection modal (admin/survey)
   "no-templates-found-title": "No templates found",
   "no-templates-found-description":
      "There aren't any templates available right now. Try again later or create a new one!",
   "sections-label": "Sections:",
   "use-template-button": "Use template",

   // Turn module into template modal (admin/survey)
   "template-created-success-title": "Template created successfully!",
   "template-created-success-description":
      "Your new template has been created from this module's structure. You can now edit it or use it to quickly create new modules.",
   "template-create-error-description":
      "We had a problem creating this template, please try again.",
   "convert-module-to-template-title": "Convert module to template",
   "module-label": "Module",
   "structure-logic-copied-note":
      "Note: Only the structure and logic will be copied, responses will not be included.",
   "create-template-button": "Create template",

   // Module survey preview/submission (admin/survey v2)
   "fetch-drafts-error": "Failed to fetch drafts",
   "module-saved-draft-success": "Module saved as draft successfully",
   "save-draft-error": "Failed to save the draft",
   "reject-module-error": "Failed to reject the module",
   "submit-module-error": "Failed to submit module",
   "preview-other-modules-text": "Preview other modules in this assessment",
   "my-saved-drafts-button": "My saved drafts",
   "save-as-draft-button": "Save as draft",
   "processing-text": "Processing...",
   "submit-module-button": "Submit module",
   "reject-module-button": "Reject module",
   "approve-module-button": "Approve module",

   // Change module status modal (admin/survey v2)
   "change-status-button": "Change status",
   "change-module-status-editing-title": "Change module status to Editing",
   "change-module-status-editing-confirm-description":
      "You're about to change the module status to Editing.",

   // Survey language / print bar (admin/survey v2)
   "language-label": "Language",
   "select-language-placeholder": "Select language",
   "print-module-button": "Print Module",

   // Save as draft modal (admin/survey v2)
   "save-as-draft-title": "Save as a draft",
   "save-draft-description":
      "To save a draft of this module, assign it a name so you can review it later. The drafts you save are stored on our database.",
   "save-draft-button": "Save Draft",

   // Drafted surveys modal (admin/survey v2)
   "start-new-draft-button": "Start a new draft",
   "my-saved-draft-title": "My saved draft",
   "unsubmitted-drafts-description": "You have unsubmitted drafts for this module.",
   "continue-draft-or-new-question": "Do you want to continue with a draft or start a new one?",
   "my-draft-label": "My draft",
   "no-drafts-found-text": "No drafts found. Start a new draft.",

   // Submit module confirmation modal (admin/survey v2)
   "submit-module-confirm-description-part1":
      "You are about to submit this module. Once you proceed, your answers will be sent to the project manager for review and approval.",
   "submit-module-confirm-description-part2":
      "Please ensure that all your responses are accurate, as you will not be able to make any changes once submitted.",

   // Approve/reject module request modals (admin/survey v2)
   "approve-request-confirm-description":
      "You're about to approve this request. This action can't be undone.",
   "feedback-required-validation": "Feedback is required",
   "reject-module-description-part1":
      "Please provide detailed feedback on why this module is being rejected.",
   "reject-module-description-part2":
      "This will serve as a guide for the responsible team member to make the necessary corrections.",
   "why-rejecting-module-label": "Why are you rejecting this module?",
   "enter-rejection-reason-placeholder": "Please enter the reason for rejection",

   // Form builder header (admin/survey v2 editor)
   "module-status-label": "Module status:",
   "survey-status-published": "Published",
   "edit-module-details-tooltip": "Edit Module Details",
   "page-preparing-text": "Page is preparing...",

   // Option bar / add question-item bar (admin/survey v2 editor)
   "add-section-to-module-tooltip": "Add section to module",
   "add-inner-section-tooltip": "Add inner section",

   // Question type labels (admin/survey v2)
   "question-type-section": "Section",
   "question-type-select-one": "Select one",
   "question-type-text": "Text",
   "question-type-file-upload": "File upload",
   "question-type-date": "Date",
   "question-type-phone-number": "Phone number",
   "question-type-rating": "Rating",
   "question-type-ranking": "Ranking",
   "question-type-select-multiple": "Select multiple",
   "question-type-note": "Note",
   "question-type-date-time": "Date & time",
   "question-type-time": "Time",
   "question-type-number": "Number",
   "question-type-acknowledge": "Acknowledge",
   "question-type-matrix": "Matrix",
   "type-section-label-placeholder": "Please type your section label",
   "type-question-label-placeholder": "Please type your question label",

   // Question editor-types (admin/survey v2)
   "option-placeholder": "Option",
   "enter-note-text-above": "Please enter your note text above.",
   "calculate-question-coming-soon": "Calculate question - coming soon...",
   "file-upload-caps-label": "FILE UPLOAD",
   "items-to-be-ranked-label": "Items to be ranked",
   "text-question-type-label": "Text Question Type",
   "question-displayed-as-table-text": "This question will be displayed as a table",
   "row-questions-title": "Row questions",
   "columns-questions-title": "Columns questions",
   "allow-numbers-range-only-text": "Allow numbers from a range only",
   "gps-question-coming-soon": "GPS question - coming soon...",
   "type-label-optional-placeholder": "Type a label (optional)",
   "optional-placeholder": "Optional",
   "reverse-answers-order-button": "Reverse answers order",
   "type-answer-choice-placeholder": "Type an answer choice",
   "label-text": "Label",
   "select-an-option-placeholder": "Select an option",
   "select-a-scale-placeholder": "Select a scale",
   "enter-bulk-action-placeholder": "Enter bulk action",
   "to-divider-label": "To",
   "collect-date-info-text": "Collect date info",
   "collect-time-info-text": "Collect time info",
   "collect-phone-number-info-text": "Collect phone number info",
   "type-a-question-placeholder": "Type a question",
   "min-label": "min:",
   "max-label": "max:",
   "max-options-chosen-text": "Maximum number of options that can be chosen",
   "all-options-label": "All",
   "answer-genius-label": "Answer genius",
   "add-choices-button": "Add Choices",
   "bulk-actions-label": "Bulk Actions",
   "enter-each-answer-choice-line-text": "Enter each answer choice on a separate line.",

   // Question editor (admin/survey v2) - EditorFooter, QuestionEditorWrapper
   "required-answer-label": "Required answer",
   "delete-question-confirm-title": "Are you sure you want to delete this question?",
   "delete-section-confirm-title": "Are you sure you want to delete this section?",
   "this-action-cannot-be-undone-text": "This action cannot be undone",
   "yes-confirm-button": "Yes",
   "no-confirm-button": "No",
   "add-new-question-button": "Add new question",
   "add-new-inner-section-button": "Add new inner section",
   "add-new-section-button": "Add new section",

   // Skip logic (admin/survey v2)
   "show-logic-button": "Show Logic",
   "display-condition-prefix-text": "Display",
   "question-word-label": "Question",
   "when-following-conditions-apply-text": "when the following conditions apply:",
   "add-another-condition-button": "Add Another Condition",
   "should-match-all-the-criteria-placeholder-text": "should match all the criteria",
   "should-match-all-of-these-criteria-text": "should match all of these criteria",
   "should-match-any-of-these-criteria-text": "should match any of these criteria",
   "operator-was-not-answered-label": "Was not answered",
   "operator-was-answered-label": "Was answered",
   "operator-equals-label": "Equals (=)",
   "operator-not-equals-label": "Not Equals (!=)",
   "operator-greater-than-label": "Greater Than (>)",
   "operator-less-than-label": "Less Than (<)",
   "operator-greater-than-or-equal-label": "Greater Than or Equal to (>=)",
   "operator-less-than-or-equal-label": "Less Than or Equal to (<=)",

   // Question submission types (admin/survey v2 preview/answer rendering)
   "field-required-text": "This field is required",
   "type-your-answer-here-placeholder": "Type your answer here",
   "you-must-select-text": "You must select",
   "you-must-enter-date-and-time-text": "You must enter a date and time",
   "you-must-enter-a-number-text": "You must enter a number",
   "drag-drop-files-text": "Drag and drop files here, or click to select files",
   "uploaded-file-label": "Uploaded File:",
   "you-must-upload-file-text": "You must upload a file",
   "all-rankings-must-be-selected-text": "All rankings must be selected",
   "please-specify-placeholder": "Please specify",
   "you-can-select-up-to-text": "You can select up to",
   "choices-suffix-text": "choices.",
   "you-must-select-at-least-one-text": "You must select at least one",
   "you-must-select-one-text": "You must select one",
   "you-must-select-a-time-text": "You must select a time",

   // Approver feature (survey Preview + approve/reject modals)
   "no-submission-made-yet-text": "No submission has been made for this module yet.",
   "approval-successful-title": "Successful",
   "submission-approved-successfully-text": "Submission approved successfully",
   "fetch-submission-answers-error": "Failed to fetch submission answers",
   "approve-without-review-button": "Approve without review",
   "send-for-approval-button": "Send for approval",
   "approve-module-pending-approver-description":
      "You are about to approve this module. Once you proceed, it will be sent to the approver for a final review before its status is marked as",
   "approve-module-final-description-part1":
      "You are about to give final approval for this module. Once you proceed, its status will be marked as",
   "approve-module-final-description-part2":
      "and its results will be available for analysis. This action can't be undone. Are you sure you want to continue?",
   "send-to-approver-for-review-label": "Send to approver for final review",
   "approver-review-recommended-hint": "Recommended - skipping this finalizes the module immediately.",
   "skipping-approver-review-warning-text":
      "You're skipping approver review. This module will finish without a second check.",
   "enter-detailed-feedback-placeholder": "Please enter your detail feedback here",

   // Approver management (admin/approver)
   "department-team-label": "Department/Team",
   "enter-approver-name-placeholder": "Enter approver name",
   "enter-approver-email-placeholder": "Enter approver email",
   "enter-approver-department-placeholder": "Enter approver department",
   "approver-added-success-title": "Approver added successfully!",
   "approver-added-success-description": "This approver can now be assigned to assessments.",
   "approver-updated-success-title": "Approver updated successfully!",
   "approver-updated-success-description": "This approver's details have been updated.",
   "approver-add-error-description": "We had a problem adding this approver, please try again.",
   "approver-update-error-description": "We had a problem updating this approver, please try again.",
   "approver-delete-error-description": "We had a problem deleting this approver, please try again.",
   "approver-deleted-success-title": "Approver deleted successfully!",
   "approver-deleted-success-description": "This approver has been removed.",
   "delete-approver-title": "Delete approver",
   "delete-approver-confirm-text": "You're about to delete this approver.",
   "add-approver-title": "Add Approver",
   "edit-approver-title": "Edit Approver",
   "add-approver-button": "Add approver",
   "approvers-title": "Approvers",
   "search-approver-by-name-placeholder": "Search an approver by its name",
   "filter-approvers-by-department-placeholder": "Filter approvers by department",

   // Approver submissions (approver-facing pages)
   "no-data-text": "No data",
   "submitted-by-column": "Submitted by",
   "pending-modules-title": "Pending modules",
   "approved-modules-title": "Approved modules",
   "rejected-modules-title": "Rejected modules",
   "filter-tasks-by-submission-date-placeholder": "Filter tasks by submission date",
   "module-approvals-title": "Module approvals",
   "pending-modules-review-description":
      "This is the list of modules pending your review. To proceed, please click on each module where you'll be able to either accept or reject it.",
   "the-approver-label": "the approver",
   "approver-label": "Approver",
   "select-an-approver-placeholder": "Select an approver",
   "go-to-revise-module-button": "Go to revise module",
   "rejected-module-information-title": "Rejected module information",
   "feedback-from-label-prefix": "Feedback from",
   "the-project-manager-label": "the project manager",
   "awaiting-approver-status": "Awaiting approver",

   // Editor page, edit panel, edit survey details (admin/survey v2 editor)
   "module-title-label": "Module title",
   "enter-module-title-placeholder": "Enter module title",
   "module-description-label": "Module Description",
   "assigned-assessment-label": "Assigned Assessment",
   "survey-updated-success-title": "Survey updated successfully!",
   "module-updated-success-description": "This module was updated correctly.",
   "edit-module-error-description": "We had a problem editing this module, please try again.",
   "form-builder-tab-label": "Form Builder",
   "logic-builder-tab-label": "Logic Builder",
   "translate-questions-tab-label": "Translate Questions",
   "score-questions-tab-label": "Score Questions",
   "stay-here-button": "Stay here",
   "change-tab-button": "Change tab",
   "unsaved-progress-title": "Unsaved progress",
   "unsaved-changes-tab-text": "You have unsaved changes on this tab.",
   "confirm-proceed-without-saving-part1": "Are you sure you want to proceed",
   "confirm-proceed-without-saving-part2": "without saving progress?",
   "module-status-changed-success-title": "Module status changed successfully!",
   "module-status-changed-success-description": "The status of this module has been changed correctly.",
   "problem-occurred-title": "A problem occurred!",
   "change-status-error-description":
      "We had a problem changing the status of this module, please try again.",
   "publish-module-button": "Publish Module",
   "change-status-to-editing-button": "Change status to Editing",
   "changes-saved-success-description": "Changes successfully saved",
   "save-progress-button": "Save Progress",
   "skip-logic-saved-success-description": "Skip logics successfully added",
   "score-points-saved-success-description": "Score points successfully added",
   "total-module-score-label": "Total Module Score:",
   "points-suffix": "pts",
   "answers-column-label": "Answers",
   "score-column-label": "Score",
   "input-score-placeholder": "Input score",
   "max-score-label": "Max Score:",
   "date-answer-label": "Date answer",
   "time-answer-label": "Time answer",
   "answer-keywords-label": "Answer keywords",
   "section-score-label": "Section score:",
   "number-range-hint-prefix": "The range for this question is",
   "number-range-hint-value": "1 to 50",
   "number-range-hint-suffix": ". Please select the rigth answer choices to scoring:",
   "select-right-answer-choices-placeholder": "Select the right answer choices",
   "single-number-option-label": "Single number",
   "range-option-label": "Range",
   "enter-range-correct-answers-label": "Enter the range of correct answers",
   "to-connector-label": "to",
   "enter-correct-number-label": "Enter the correct number",
   "input-number-placeholder": "Input number",
   "ranking-score-instructions-text":
      "Please organize the options in the correct order, later give them a score to each on",
   "input-phone-number-placeholder": "Input phone number",

   // Translate panel (admin/survey v2 editor)
   "main-module-title": "Main Module",
   "main-module-description-text": "These are que questions from your main module",
   "default-language-placeholder": "Default Language",
   "translate-module-title": "Translate Module",
   "write-translation-here-text": "Write down the translation of each question here",
   "translate-to-label": "Translate To",
   "select-a-language-placeholder": "--Select a Language--",
   "select-language-first-error": "Please select a language first",
   "translation-saved-success-description": "Translation successfully saved",
   "save-translation-button": "Save translation",

   // Action Plan admin-side resource/expert modals (workspace/actionPlan/adminActionPlan)
   "module-required-validation": "Module is required",
   "at-least-one-section-required-validation": "At least one section is required",
   "resource-type-required-validation": "Resource type is required",
   "at-least-one-attachment-required-validation": "At least one attachment is required",
   "description-required-validation": "Description is required",
   "tagged-topics-required-validation": "Tagged topics are required",
   "invalid-url-format-validation": "Invalid URL format",
   "link-url-required-validation": "Link URL is required",
   "agree-to-terms-required-validation": "You must agree to the terms",
   "section-required-validation": "Section is required",
   "resources-added-success-title": "Resources added successfully!",
   "resources-added-success-description": "These resources have been created and added to your database.",
   "upload-resource-matching-type-error": "Please upload a resource that matches the selected type.",
   "resources-updated-success-title": "Resources updated successfully!",
   "resources-updated-success-description": "These resources have been updated successfully.",
   "add-new-resource-title": "New resource",
   "edit-resource-title": "Edit resource",
   "resource-upload-shared-repository-notice":
      "Any resource you upload to the platform will be published in KAPorg's shared repository, making it available for other users to download and share, while fostering community support.",
   "select-module-link-resource-label": "Select the module you want to link this resource to",
   "all-modules-in-assessment-placeholder": "All modules in this assessment",
   "select-section-link-resource-label":
      "Select the section of the module you want to link this resource to",
   "all-sections-of-module-placeholder": "All sections of the module",
   "resource-information-title": "Resource information",
   "select-resource-type-label": "Select the resource type",
   "before-upload-select-type-hint": "Before uploading a resource you must select its type",
   "paste-link-here-label": "Paste the link here",
   "enter-link-url-placeholder": "Enter the link URL",
   "upload-file-here-label": "Upload the file here",
   "drag-drop-file-here-prefix": "Drag and drop file here, or",
   "click-to-select-file-text": "click to select file it",
   "max-file-size-text": "Max file size: 20MB",
   "enter-resource-description-label": "Enter the description of the resource",
   "tagged-topics-label": "Tagged topics",
   "enter-tagged-topics-placeholder":
      "Enter the topics with which this resource can be related",
   "upload-rights-confirmation-text":
      "By uploading this material, I confirm that I have the necessary rights and permissions to do so.",
   "add-resource-button": "Add resource",
   "expert-name-column": "Expert name",
   "operating-countries-column": "Operating countries",
   "years-of-experience-column": "Years of experience",
   "expert-cv-column": "Expert CV",
   "areas-of-expertise-column": "Areas of expertise",
   "assign-experts-to-assessment-title": "Assign experts to this assessment",
   "select-expert-assign-assessment-text":
      "Select the expert you would like to assign to this assessment.",
   "search-resource-by-name-placeholder": "Search a resource by its name",
   "assign-expert-to-assessment-button": "Assign expert to this assessment",
   "expert-assigned-success-title": "Expert assigned successfully!",
   "expert-assigned-success-description":
      "This expert has been assigned and added to your action plan database.",
   "assign-expert-error-description":
      "We had a problem assigning this expert to your action plan, please try again.",
   "expert-removed-success-title": "Expert removed successfully!",
   "expert-removed-success-description":
      "This expert has been removed from your action plan database.",
   "remove-expert-from-assessment-button": "Remove expert from this assessment",
   "email-label-colon": "Email:",
   "description-label-colon": "Description:",
   "no-description-available-text": "No description available",
   "no-expertise-listed-text": "No expertise listed",
   "field-of-study-label": "Field of study",
   "no-field-of-study-listed-text": "No field of study listed",
   "no-operating-countries-listed-text": "No operating countries listed",
   "languages-label": "Languages",
   "no-languages-listed-text": "No languages listed",
   "linkedin-profile-label": "LinkedIn profile",
   "no-linkedin-profile-text": "No LinkedIn profile provided",
   "delete-collection-title": "Delete collection",
   "delete-collection-confirm-text":
      "You're about to delete this collection. This action can’t be undone.",
   "delete-resource-title": "Delete resource",
   "delete-resource-confirm-text":
      "You're about to delete this resource. This action can’t be undone.",
   "collection-deleted-success-title": "Collection deleted successfully!",
   "collection-deleted-success-description":
      "This collection was successfully removed from your database.",
   "resource-deleted-success-title": "Resource deleted successfully!",
   "resource-deleted-success-description":
      "This resource was successfully removed from your database.",
   "delete-resource-error-description": "We had a problem deleting this resource, please try again.",
   "resource-preview-title": "Resource preview",
   "document-type-label": "Document",
   "video-type-label": "Video",
   "slide-type-label": "Slide",
   "tags-and-categories-label": "Tags and categories",
   "upload-date-label": "Upload date",
   "description-label": "Description",

   // Action Plan view/manager-side task modals (workspace/actionPlan/viewActionPlan)
   "status-label-colon": "Status:",
   "assign-to-label-colon": "Assign to:",
   "deadline-label-colon": "Deadline:",
   "resources-attached-section-text": "Resources attached to this section",
   "resource-link-label-colon": "This is the link of the resource:",
   "task-title-required-validation": "Task title is required",
   "deadline-required-validation": "Deadline is required",
   "create-new-task-title": "Create a new task",
   "edit-task-title": "Edit task",
   "task-title-label": "Task title",
   "task-title-example-placeholder": "How frequently do you provide training to your employees?",
   "enter-task-instruction-placeholder":
      "Enter a note or instruction that helps the person assigned to do the task",
   "assign-task-to-label": "Assign task to",
   "select-member-assign-task-placeholder": "Select the member to assign this task",
   "cant-find-member-assign-task-text": "Can't find the member to assign a task?",
   "add-in-organization-management-text": "Add it in organization management",
   "upload-files-complete-task-label": "Upload files necessary to complete this task",
   "can-add-up-to-3-resources-text": "You can add up to 3 resources",
   "deadline-label": "Deadline",
   "resource-link-optional-label": "Is your resource a link? Please enter it here",
   "enter-resource-link-placeholder": "Enter the link of your resource",
   "assign-task-title": "Assign task",
   "assign-task-at-least-one-member-validation": "Assign task to at least one member",
   "deadline-valid-date-validation": "Deadline must be a valid date",
   "select-deadline-placeholder": "Select deadline",
   "task-added-assigned-success-title": "Task added and assigned successfully!",
   "task-added-assigned-success-description":
      "This task was successfully assigned, the member that you selected will be notified about it.",
   "assign-task-error-description": "We had a problem assigning this task, please try again.",
   "select-status-title": "Select status",
   "task-updated-success-title": "Task updated successfully!",
   "task-updated-success-description": "This task was successfully updated in your database.",
   "update-task-error-description": "We had a problem updating this task, please try again.",
   "task-deleted-success-title": "Task deleted successfully!",
   "task-deleted-success-description": "This task was successfully removed from your database.",
   "delete-task-error-description": "We had a problem deleting this task, please try again.",
   "delete-task-title": "Delete task",
   "delete-task-confirm-text": "You're about to delete this task. This action can't be undone.",
   "rounds-filter-label": "Rounds",
   "managers-filter-label": "Managers",
   "generate-report-button": "Generate report",
   "generate-report-title": "Generate Report",
   "choose-sections-report-text": "Choose which sections to include in the report.",
   "include-module-breakdown-label": "Include Module Breakdown",
   "of-label": "of",
   "sections-selected-suffix": "sections selected",
   "generate-button": "Generate",
   "report-preview-title": "Report preview",
   "edit-sections-button": "Edit sections",
   "assessment-report-eyebrow-text": "Assessment Report",
   "no-sections-data-selected-text": "No sections with data selected.",
   "assessment-report-pdf-heading": "ASSESSMENT REPORT",
   "exported-on-label": "Exported on",
   "page-word": "Page",
   "add-review-note-title": "Add review note",
   "edit-review-note-title": "Edit review note",
   "note-title-required-validation": "Please enter a note title",
   "enter-note-title-placeholder": "Enter note title",
   "round-covered-label": "Round covered",
   "select-option-required-validation": "Please select an option",
   "note-required-validation": "Please enter your notes",
   "summarize-progress-placeholder": "Summarize key progress, decisions, or issues.",
   "add-note-button": "Add note",
   "staff-members-fetch-error": "We had a problem fetching staff members, please refresh the page.",
   "task-priority-fetch-error": "We had a problem fetching task priority, please refresh the page.",
   "select-section-add-task-error": "Please select a section to add this task.",
   "add-task-error-description": "We had a problem adding this task, please try again.",
   "add-new-task-title": "Add new task",
   "task-name-label": "Task name",
   "task-name-required-validation": "Please enter a task name",
   "enter-task-name-placeholder": "Enter task name",
   "linked-questions-label": "Linked questions",
   "select-questions-required-validation": "Please select questions",
   "linked-questions-helper-text": "Select the questions this task is meant to improve",
   "select-questions-placeholder": "Select the questions",
   "task-description-required-validation": "Please enter a description",
   "enter-task-description-placeholder": "Enter the description of the task",
   "select-member-required-validation": "Please select a member",
   "select-deadline-required-validation": "Please select a deadline",
   "priority-label": "Priority",
   "select-priority-required-validation": "Please select priority",
   "select-priority-placeholder": "Select the priority",
   "resources-label": "Resources",
   "select-resources-placeholder": "Select the resources linked to this tasks",
   "select-resources-required-validation": "Please select resources",
   "search-resource-placeholder": "Search a resource",
   "browse-resources-library-text": "Browse resources library",
   "add-task-button": "Add task",
   "confirm-selection-button": "Confirm selection",
   "resource-library-title": "Resource Library",
   "collections-tab-label": "Collections",
   "workspace-breadcrumb-label": "Workspace",
   "resources-breadcrumb-label": "Resources",
   "results-breadcrumb-label": "Results",
   "action-plan-breadcrumb-label": "Action plan",
   "respondents-count-label": "respondents",
   "of-word": "of",
   "copy-tasks-title": "Copy tasks",
   "copy-tasks-description-text":
      "All tasks from your previous round will be copied to ensure your action plan is complete as it grows over time.",
   "previous-round-label": "Previous round:",
   "tasks-copied-label": "Tasks copied",
   "task-statistics-fetch-error": "We had a problem loading task statistics, please try again.",
   "delete-note-confirm-text":
      "You're about to delete this review note. This action can't be undone.",
   "delete-view-title": "Delete view",
   "delete-view-confirm-text": "You're about to delete this view. This action can't be undone.",
   "rename-view-title": "Rename view",
   "save-button": "Save",
   "select-a-resource-title": "Select a resource",
   "set-a-reminder-title": "Set a reminder",
   "reminder-description-text":
      "Choose when you'd like to be reminded to add or update your team's progress notes.",
   "reminder-type-label": "Reminder type",
   "select-reminder-type-required-validation": "Please select a reminder type",
   "select-day-required-validation": "Please select a day",
   "select-a-day-placeholder": "Select a day",
   "reminder-repeat-prefix-text":
      "This will be your first reminder date. Future reminders will repeat every",
   "repeat-interval-week": "week",
   "repeat-interval-2-weeks": "2 weeks",
   "repeat-interval-month": "month",
   "repeat-interval-3-months": "3 months",
   "repeat-interval-year": "year",
   "reminder-repeat-suffix-text": "on the same day.",
   "next-reminder-date-label": "Next reminder date:",
   "save-reminder-button": "Save reminder",
   "my-workspaces-tab": "My workspaces",
   "all-workspaces-tab": "All workspaces",
   "fetch-workspaces-error-description": "We had a problem fetching the workspaces, please try again.",
   "archived-workspaces-title": "Archived workspaces",
   "deleted-workspaces-button": "Deleted workspaces",
   "new-workspace-button": "New workspace",
   "remove-action": "Remove",
   "workspace-name-label": "Workspace name",
   "enter-workspace-name-placeholder": "Enter your workspace name",
   "workspace-description-label": "Workspace description",
   "enter-workspace-description-placeholder": "Enter workspace description",
   "workspace-countries-label": "Workspace countries",
   "select-a-country-placeholder": "Select a country",
   "workspace-assessment-label": "Workspace assessment",
   "select-default-assessment-survey-placeholder": "Select the default assessment of the survey",
   "select-default-assessment-module-placeholder": "Select the default assessment of the module",
   "workspace-duplicate-name-validation": "This workspace already exists. Please try another one.",
   "workspace-created-success-title": "Workspace created successfully!",
   "workspace-created-success-description":
      "A new workspace has been created and added to your database",
   "create-workspace-error-description": "We had a problem creating this workspace, please try again.",
   "add-new-workspace-title": "Add new workspace",
   "workspace-updated-success-title": "Workspace updated successfully!",
   "workspace-updated-success-description": "This workspace was updated successfully.",
   "update-workspace-error-description": "We had a problem updating this workspace, please try again.",
   "edit-workspace-title": "Edit workspace",
   "at-least-one-assessment-required-validation": "At least one assessment is required",
   "workspace-archived-success-title": "Workspace archived successfully!",
   "workspace-archived-success-description": "This workspace was successfully archived.",
   "archive-workspace-error-description": "We had a problem archiving this workspace, please try again.",
   "archive-workspace-title": "Archive Workspace",
   "archive-workspace-confirm-text": "You're about to archive this workspace.",
   "workspace-deleted-success-title": "Workspace deleted successfully!",
   "workspace-deleted-success-description": "This workspace was successfully removed.",
   "delete-workspace-error-description": "We had a problem deleting this workspace, please try again.",
   "delete-workspace-title": "Delete Workspace",
   "delete-workspace-confirm-text": "You're about to delete this workspace.",
   "workspace-restored-success-title": "Workspace restored successfully!",
   "restore-workspace-error-description": "We had a problem restoring this workspace, please try again.",
   "workspace-deleted-permanently-success-description":
      "This workspace has been successfully deleted from your database.",
   "restore-assessment-error-description": "We had a problem restoring this assessment, please try again.",
   "restore-workspaces-button": "Restore workspaces",
   "delete-workspace-permanently-title": "Delete workspace permanently",
   "delete-workspace-permanently-confirm-text":
      "You're about to delete this workspace permanently. This action can't be undone.",
   "workspaces-unarchived-success-title": "Workspaces unarchived successfully!",
   "workspaces-unarchived-success-description":
      "This workspaces has been unarchived and added to your database.",
   "unarchive-workspace-error-description": "We had a problem unarchiving this workspace, please try again.",
   "workspaces-deleted-success-title": "Workspaces deleted successfully!",
   "workspaces-deleted-success-description": "This workspaces has been deleted from your database.",
   "deleted-workspaces-list-title": "Deleted workspaces list",
   "deleted-workspaces-retention-text":
      "Here you can view and restore deleted workspaces. Any workspaces that have not been restored within 60 days will be permanently deleted.",
   "request-canceled-success-title": "Request canceled successfully!",
   "request-canceled-success-description": "Your request was canceled.",
   "cancel-request-error-description": "We had a problem canceling this request, please try again.",
   "cancel-request-button": "Cancel Request",
   "send-request-success-description":
      "Your request was sent to the admin. As soon as the request is answered you will receive an email.",
   "send-request-error-description": "We had a problem sending your request, please try again.",
   "no-workspaces-here-title": "No workspaces here!",
   "request-part-workspace-description":
      "But don't worry, you can request to be part of a workspace on the “All workspaces” section.",
   "go-to-all-workspaces-button": "Go to All workspaces",
   "create-workspaces-tagline-text":
      "Create workspaces tailored to foster organizations growth and optimization.",
   "export-workspaces-button": "Export Workspaces",
   "all-workspaces-consultant-heading": "All Workspaces",
   "assess-partners-consultant-description":
      "Start assesing local Partners/NGOs and provide them with a detailed report of their current performance.",
   "access-workspace-organization-text": "Access a workspace and start accessing your organization.",
   "no-workspace-created-yet-description":
      "It seems you haven't created any workspace yet. But don't worry, you can create them here.",
   "untitled-label": "Untitled",
   "no-section-label": "No Section",
   "swot-analysis-title": "SWOT Analysis",
   "swot-analysis-subtitle-text": "Analyze strengths, weaknesses, opportunities, and threats",
   "related-module-label": "Related Module",
   "select-module-placeholder": "Select module",
   "enter-analysis-description-placeholder": "Enter the description of the analysis",
   "swot-strengths-title": "Strengths",
   "swot-weaknesses-title": "Weaknesses",
   "swot-opportunities-title": "Opportunities",
   "swot-threats-title": "Threats",
   "related-sections-label": "Related Sections",
   "select-sections-placeholder": "Select sections",
   "analysis-label": "Analysis",
   "describe-strengths-placeholder": "Describe the strengths",
   "describe-weaknesses-placeholder": "Describe the weaknesses",
   "describe-opportunities-placeholder": "Describe the opportunities",
   "describe-threats-placeholder": "Describe the threats",
   "add-analysis-button": "Add analysis",
   "scores-label": "Scores",
   "guided-assessment-label": "Guided assessment",
   "self-assessment-label": "Self assessment",
   "highlights-title": "Highlights",
   "highlights-subtitle-text": "Highlight key findings and provide recommendations based on results",
   "choose-chart-analyze-label": "Choose the chart you want to analyze",
   "select-chart-analyze-text": "Select the chart you want to analyze",
   "change-button": "Change",
   "select-a-module-first-placeholder": "Select a module first",
   "add-comparison-label": "Add Comparison",
   "insight-label": "Insight",
   "max-400-characters-validation": "Maximum 400 characters",
   "describe-key-points-placeholder": "Describe the key points you want to highlight from this chart...",
   "select-chart-to-analyze-title": "Select a chart to analyze",
   "choose-chart-from-list-text": "Choose one of the available charts from the list to analysis.",
   "report-title": "Report",
   "upload-report-insights-text":
      "Upload your report so it becomes part of the insights for this assessment.",
   "upload-file-here-label": "Upload the file here",
   "current-file-text": "Current file",
   "remove-file-aria-label": "Remove file",
   "doc-pdf-pptx-text": "DOC, PDF or PPTX",
   "only-doc-pdf-pptx-error": "Only DOC, PDF or PPTX files are allowed.",
   "file-must-be-smaller-than-prefix": "File must be smaller than",
   "missing-assessment-org-warning": "Missing assessment or organization details.",
   "upload-report-file-warning": "Please upload a report file.",
   "title-required-validation": "Title is required",
   "ticket-type-required-validation": "Ticket type is required",
   "message-required-validation": "Message is required",
   "ticket-added-success-title": "Ticket added successfully!",
   "ticket-added-success-description":
      "This ticket was successfully added to your ticket history database, someone will respond to your request very soon.",
   "add-ticket-error-description": "We had a problem adding this ticket, please try again.",
   "upload-jpg-png-gif-webp-error": "Please upload JPG, PNG, GIF or WEBP files only.",
   "add-new-ticket-title": "Add a new ticket",
   "ticket-type-label": "Ticket type",
   "select-ticket-type-placeholder": "Select the ticket type",
   "summary-label": "Summary",
   "enter-title-placeholder": "Enter title",
   "describe-problem-detail-label": "Describe the problem in detail",
   "type-something-placeholder": "Type something here",
   "attach-evidence-label": "Attach any evidence you consider important",
   "jpg-png-gif-webp-text": "JPG, PNG, GIF and WEBP",
   "add-ticket-button": "Add ticket",
   "tickets-deleted-success-title": "Selected tickets have been deleted successfully!",
   "tickets-deleted-success-description": "These selected tickets were successfully deleted successfully",
   "delete-tickets-error-description":
      "We had a problem deleting these selected tickets, please try again.",
   "delete-selected-tickets-title": "Delete selected tickets",
   "delete-selected-tickets-confirm-text": "You're about to delete these selected tickets.",
   "collection-updated-success-title": "Collection updated successfully!",
   "collection-updated-success-description": "This collection was updated correctly.",
   "update-collection-error-description": "We had a problem updating this collection, please try again.",
   "collection-added-success-title": "Collection added successfully!",
   "collection-added-success-description":
      "This collection has been created and added to your database.",
   "add-collection-error-description": "We had a problem adding this collection, please try again.",
   "edit-collection-title": "Edit collection",
   "add-new-collection-title": "Add new collection",
   "new-collection-button-label": "New Collection",
   "name-collection-label": "Name collection",
   "enter-collection-name-placeholder": "Enter collection name",
   "enter-collection-description-placeholder": "Enter the description of the collection",
   "select-the-assessment-label": "Select the assessment",
   "select-resources-collection-placeholder": "Select the resources linked to this collection",
   "see-more-text": "See more",
   "make-collection-public-label": "Make this collection public and visible to everyone",
   "add-collection-button": "Add collection",
   "global-status": "Global",
   "owner-colon-label": "Owner:",
   "resources-colon-label": "Resources:",
   "resource-added-collection-success-title": "Resource added to collection!",
   "resource-added-collection-success-description":
      "This resource was successfully added to the collection.",
   "add-resource-collection-error-description":
      "We had a problem adding this resource to the collection, please try again.",
   "add-to-collection-title": "Add to collection",
   "resource-updated-success-title": "Resource updated successfully!",
   "resource-updated-success-description":
      "This resource was updated correctly. A new version was created",
   "update-resource-error-description": "We had a problem updating this resource, please try again.",
   "resource-added-success-title": "Resource added successfully!",
   "resource-added-success-description":
      "This resource has been created and added to your database.",
   "add-resource-error-description": "We had a problem adding this resource, please try again.",
   "edit-resource-title": "Edit resource",
   "select-resource-type-label": "Select the resource type",
   "select-resource-type-required-validation": "Please select resource type",
   "video-placeholder-text": "Video",
   "select-type-before-upload-text": "Before uploading a resource you must select its type",
   "enter-resource-link-label": "Please enter the resource link here",
   "valid-url-required-validation": "Please put a valid url",
   "enter-resource-link-placeholder": "Enter the link of your resource",
   "select-a-file-required-validation": "Please select a file",
   "click-to-select-files-text": "click to select files",
   "resource-version-colon-label": "Resource version:",
   "make-resource-private-label": "Make this resource private",
   "resource-name-label": "Resource name",
   "enter-resource-name-placeholder": "Enter the name of the resource",
   "tags-label": "Tags",
   "enter-resource-tags-placeholder": "Enter the topics with which this resource can be related",
   "select-module-label": "Select the module",
   "select-section-label": "Select the section",
   "upload-consent-text":
      "Any resource you upload will be stored in KAPorg's repository according to the visibility you choose, making it available to the selected audience. By proceeding, you confirm that you have the necessary rights and permissions to upload this material.",
   "add-resource-button": "Add resource",
   "file-label": "File",
   "views-suffix": "Views",
   "rating-suffix": "Rating",
   "owner-label": "Owner",
   "visibility-label": "Visibility",
   "linked-to-label": "Linked to",
   "last-update-date-label": "Last update date",
   "resource-version-label": "Resource version",
   "targets-updated-success-title": "Targets updated successfully!",
   "targets-updated-success-description": "All the changes have been saved successfully.",
   "save-targets-error-description": "We had a problem saving all the changes, please try again.",
   "current-target-label": "Current target:",
   "no-active-rounds-text": "No active rounds",
   "no-target-set-yet-text": "No target set yet",
   "no-assessments-found-text": "No assessments found",
   "no-modules-yet-title": "No Modules Yet",
   "no-modules-assigned-description":
      "This assessment doesn't have any modules assigned. They will appear here once they're added.",
   "enter-target-placeholder": "Enter target",
   "ticket-history-title": "Ticket history",
   "help-desk-title": "Help desk",
   "delete-selected-rows-text": "Delete selected rows",
   "add-new-ticket-text": "New ticket",
   "subject-column": "Subject",
   "creation-date-column": "Creation Date",
   "organization-column": "Organization",
   "last-response-column": "Last response",
   "ticket-preview-title": "Ticket preview",
   "ticket-status-closed": "Closed",
   "ticket-summary-title": "Ticket summary",
   "user-email-label": "User email",
   "ticket-subject-label": "Ticket subject",
   "mark-as-resolved-button": "Close Ticket",
   "mark-ticket-resolved-title": "Close this ticket?",
   "mark-ticket-resolved-confirm-text": "Are you sure you want to close this ticket? The organization can still reply if they need further help.",
   "ticket-resolved-success-title": "Ticket closed",
   "ticket-resolved-success-description": "The ticket has been closed.",
   "resolve-ticket-error-description": "Something went wrong while closing the ticket. Please try again.",
   "type-your-message-placeholder": "Type your message here...",
   "filter-tickets-by-type-placeholder": "Filter by type",
   "filter-tickets-by-status-placeholder": "Filter by status",
   "summary-results-title": "Summary Results",
   "graphs-view-tab": "Graphs view",
   "table-view-tab": "Table view",
   "expert-insights-tab": "Expert Insights",
   "no-dashboard-results-yet-title": "This dashboard doesn't have results yet",
   "results-appear-here-description": "Once data is available, your results will appear here.",
   "submission-round-column": "Submission round",
   "submission-label-column": "Submission label",
   "select-module-first-text": "Please select a module first.",
   "select-at-least-one-submission-round-text": "Please select at least one submission round.",
   "unable-detect-organization-text": "Unable to detect your organization. Please sign in again.",
   "download-table-label": "Download table",
   "score-overview-title": "Score overview",
   "toggle-score-overview-aria-label": "Toggle score overview",
   "visualizations-title": "Visualizations",
   "search-a-graph-placeholder": "Search a graph",
   "select-view-placeholder": "Select view",
   "save-view-button": "Save view",
   "save-dashboard-button": "Save dashboard",
   "edit-dashboard-button": "Edit dashboard",
   "download-dashboard-label": "Download dashboard",
   "round-label": "Round",
   "manager-label": "Manager",
   "select-an-organization-placeholder": "Select an organization",
   "select-all-option": "Select all",
   "all-placeholder": "All",
   "score-percent-label": "Score (%)",
   "task-completion-percent-label": "Task Completion (%)",
   "task-status-percent-label": "Task status (%)",
   "value-label": "Value",
   "first-round-label": "First round",
   "second-round-label": "Second round",
   "improvement-percent-label": "Improvement %",
   "result-label": "Result",
   "current-label": "Current",
   "target-word": "Target",
   "overall-score-label": "Overall score",
   "of-tasks-completed-label": "of tasks completed",
   "leading-label": "Leading",
   "developing-label": "Developing",
   "lagging-label": "Lagging",
   "section-word": "Section",
   "task-completion-label": "Task completion",
   "indicator-word": "Indicator",
   "progress-word": "Progress",
   "current-round-label": "Current Round:",
   "change-label": "Change:",
   "improvement-label": "Improvement",
   "task-count-label": "Task count",
   "assessment-results-per-module-title": "Assessment results per module",
   "assessment-results-per-section-title": "Assessment results per section",
   "performance-map-title": "Performance Map",
   "assessment-results-per-organization-title": "Assessment results per organization",
   "module-results-per-organization-title": "Module results per organization",
   "section-results-per-organization-title": "Section results per organization",
   "assessment-targets-per-organization-title": "Assessment targets per organization",
   "module-targets-per-organization-title": "Module targets per organization",
   "section-targets-per-organization-title": "Section targets per organization",
   "improvement-tracker-per-organization-title": "Improvement tracker per organization",
   "target-score-task-progress-per-organization-title": "Target, score and task progress per organization",
   "assessment-results-per-round-title": "Assessment results per round",
   "module-results-per-round-title": "Module results per round",
   "section-results-per-round-title": "Section results per round",
   "assessment-targets-per-round-title": "Assessment targets per round",
   "module-targets-per-round-title": "Module targets per round",
   "section-targets-per-round-title": "Section targets per round",
   "improvement-tracker-per-assessment-title": "Improvement tracker per assessment",
   "target-score-task-progress-per-assessment-title": "Target, score and task progress per assessment",
   "radar-chart-type-label": "Radar chart",
   "tier-list-type-label": "Tier list",
   "score-progress-across-rounds-title": "Score progress across rounds",
   "module-score-progress-across-rounds-title": "Module score progress across rounds",
   "bar-chart-type-label": "Bar chart",
   "table-type-label": "Table",
   "modules-word": "Modules",
   "sections-word": "Sections",
   "task-status-per-assessment-title": "Task status per assessment",
   "module-task-completion-title": "Module task completion",
   "section-task-completion-title": "Section task completion",
   "task-completion-per-organization-title": "Task completion per organization",
   "improvement-tracker-title": "Improvement tracker",
   "donut-chart-type-label": "Donut chart",
   "task-updated-success-message": "Task updated successfully.",
   "task-added-success-message": "Task added successfully.",
   "export-tasks-error-message": "We had a problem exporting tasks, please try again.",
   "tasks-copied-success-title": "Tasks copied successfully!",
   "tasks-copied-success-description": "All tasks from the previous round have been copied to the current round.",
   "results-not-yet-approved-title": "Results not yet approved!",
   "results-not-yet-approved-description": "Tasks can only be copied once all modules in this assessment have approved submissions. Please approve your submissions before copying tasks.",
   "tasks-already-copied-title": "Tasks already copied for this round",
   "tasks-already-copied-description": "Tasks can only be copied once per round. If you're missing tasks, please contact your administrator.",
   "copy-tasks-error-title": "Oops! A problem has occurred!",
   "copy-tasks-error-description": "We had a problem copying the tasks from the previous round, please try again.",
   "resource-label-colon": "Resource:",
   "edit-module-alt-text": "Edit module",
   "delete-module-alt-text": "Delete module",
   "task-status-updated-message": "Task status updated.",
   "failed-update-task-status-message": "Failed to update task status.",
   "plan-summary-title": "Plan Summary",
   "select-organization-to-view-plan-text": "Select an organization above to view its plan summary.",
   "select-organization-placeholder": "Select organization",
   "previous-round-readonly-notice-text": "This is a previous round and is read-only to preserve its data. You can only make changes in the current round.",
   "viewing-previous-round-button": "You're viewing a previous round",
   "go-to-current-round-button": "Go to current round",
   "staff-member-label": "Staff Member",
   "export-plan-button": "Export plan",
   "task-column-header": "Task",
   "responsible-column-header": "Responsible",
   "due-date-column-header": "Due Date",
   "see-less-link": "See less",
   "see-all-link": "See all",
   "no-linked-questions-text": "No linked questions",
   "resources-label-colon": "Resources:",
   "no-tasks-for-staff-member-text": "No tasks found for the selected staff member",
   "add-tasks-improve-score-text": "Add tasks to this indicator to improve your score",
   "result-label-colon": "Result:",
   "target-label-colon": "Target:",
   "review-note-added-success-description": "Review note has been added successfully.",
   "reminder-set-title": "Reminder set",
   "reminder-scheduled-success-description": "Your reminder has been scheduled successfully.",
   "review-notes-title": "Review notes",
   "set-reminder-button": "Set reminder",
   "print-summary-button": "Print summary",
   "export-notes-button": "Export notes",
   "note-word": "Note",
   "no-note-created-yet-text": "No note has been created yet.",
   "no-review-notes-available-text": "No review notes available.",
   "no-score-selected-text": "No score selected",
   "filters-colon-label": "Filters:",
   "none-word": "None",
   "graph-word": "Graph",
   "no-chart-content-text": "No chart content",
   "filter-colon-label": "Filter:",
   "action-plan-word": "Action Plan",
   "results-word": "Results",
   "no-charts-available-title": "No charts available",
   "no-charts-data-export-text": "No charts with data available for export.",
   "summary-action-plan-dashboard-title": "Summary Action Plan Dashboard",
   "summary-results-dashboard-title": "Summary Results Dashboard",
   "assessment-colon-label": "Assessment:",
   "assessment-word": "Assessment",
   "download-svg-action": "Download SVG",
   "download-png-action": "Download PNG",
   "included-in-report-tooltip-text": "Included when generating the report",
   "no-visualization-selected-text": "No visualization selected",
   "drop-visualization-here-text": "Drop visualization here",
   "add-graph-button": "Add graph",
   "delete-block-tooltip-text": "Delete block",
   "no-filters-selected-text": "No filters selected",
   "filters-word": "Filters",
   "untitled-graph-text": "Untitled graph",
   "graph-preview-unavailable-text": "Graph preview unavailable",
   "filter-word": "Filter",
   "global-suffix-label": "(global)",
   "organization-word": "Organization",
   "staff-word": "Staff",
   "generic-problem-occurred-title": "Oops! A problem has occurred",
   "view-saved-success-title": "View saved successfully!",
   "view-saved-success-description": "Your dashboard view was saved successfully.",
   "problem-saving-view-description": "We had a problem saving this view, please try again.",
   "select-view-before-rename-text": "Select a view before renaming.",
   "select-view-before-delete-text": "Select a view before deleting.",
   "view-deleted-success-title": "View deleted successfully!",
   "view-deleted-success-description": "The selected view was deleted from your dashboard.",
   "problem-deleting-view-description": "We had a problem deleting this view, please try again.",
   "view-renamed-success-title": "View renamed successfully!",
   "view-renamed-success-description": "The selected view name was updated successfully.",
   "problem-renaming-view-description": "We had a problem renaming this view, please try again.",
   "view-word": "View",
   "compare-with-self-assessment-label": "Compare with self assessment",
   "comparison-limited-one-org-text": "This comparison is limited to one organization at a time",
   "assessment-not-linked-self-text": "This assessment is not linked to a self assessment",
   "dashboard-word": "Dashboard",
   "self-assessments-menu-item": "Self assessments",
   "guided-assessments-menu-item": "Guided assessments",
   "module-request-menu-item": "Module Request",
   "action-plan-menu-item": "Action plan",
   "my-performance-menu-item": "My performance",
   "task-management-menu-item": "Task management",
   "resources-menu-item": "Resources",
   "organization-management-menu-item": "Organization management",
   "quick-search-tooltip-text": "Quick Search",
   "notifications-tooltip-text": "Notifications",
   "help-desk-word": "Help Desk",
   "go-back-previous-menu-text": "Go back to previous menu",
   "go-back-to-action-plan-link": "Go back to action plan",
   "go-back-to-module-list-link": "Go back to module list",
   "go-back-to-modules-list-link": "Go back to modules list",
   "go-back-to-templates-list-link": "Go back to templates list",
   "go-back-to-action-plan-section-link": "Go back to action plan section",
   "go-back-to-assessment-link": "Go back to assessment",
   "go-back-to-assessments-link": "Go back to assessments",
   "go-back-to-assigned-modules-list-link": "Go back to Assigned modules list",
   "go-back-to-approved-modules-list-link": "Go back to Approved modules list",
   "go-back-to-pending-modules-list-link": "Go back to Pending modules list",
   "go-back-to-guided-assessment-link": "Go back to guided assessment",
   "go-back-to-guided-assessment-list-link": "Go back to guided assessment list",
   "go-back-to-workspaces-link": "Go back to workspaces",
   "profile-preview-alt-text": "Profile Preview",
   "org-role-abbreviation": "Org",
   "role-super-admin-label": "Super Admin",
   "role-consultant-label": "Consultant",
   "role-donor-label": "Donor",
   "role-national-organization-label": "National Organization",
   "role-international-organization-label": "International Organization",
   "male-label": "Male",
   "female-label": "Female",
   "no-self-assessments-here-text": "No self assessments here",
   "no-guided-assessments-here-text": "No guided assessments here",
   "self-assessment-panel-title": "Self assessment",
   "guided-assessment-panel-title": "Guided assessment",
   "sort-progress-by-label": "Sort progress by:",
   "highest-to-lowest-option": "Highest to lowest",
   "lowest-to-highest-option": "Lowest to highest",
   "modules-count-suffix": "modules",
   "answer-pending-status": "Answer pending",
   "unlock-assessment-text": "Unlock assessment",
   "select-assessment-see-results-text": "Select an assessment to see its results in detail.",
   "linked-badge-label": "Linked",
   "no-assessments-available-title": "No assessments available.",
   "start-adding-view-results-text": "Start by adding one to view the collected results.",
   "assessment-selected-suffix": "assessment selected",
   "action-plan-panel-description-text": "Here you will find an action plan based on your results in each assessment.",
   "select-one-see-plan-detail-text": "Select one to see the plan in detail.",
   "search-for-assessment-placeholder": "Search for an assessment",
   "areas-to-improve-label": "Modules to Improve:",
   "no-assessments-here-text": "No assessments here!",
   "selected-assessment-title": "Selected assessment",
   "no-assessment-selected-text": "No assessment selected",
   "number-of-resources-label": "Number of Resources:",
   "areas-in-label": "Areas:",
   "indicators-to-improve-label": "Indicators to Improve:",
   "no-data-available-to-display-text": "There is no data available to be displayed.",
   "self-evaluate-screen-description-text": "This screen allows you to evaluate yourself based on the questionnaires you have solved",
   "maximum-organizations-warning-text": "Maximum 5 organizations!",
   "search-organization-placeholder": "Search organization",
   "sort-order-tooltip-text": "Sort Order",
   "get-results-tooltip-text": "Get results",
   "report-word": "Report",
   "capacity-gaps-title": "Capacity Gaps",
   "capacity-gaps-description-text": "Which modules and sections are strong and which are weak, and how they perform against their targets.",
   "performance-overview-title": "Performance Overview",
   "performance-overview-description-text": "Where the cohort stands this round: organization scores, how they spread across the assessment's score categories, and how they sit against the round target.",
   "progress-across-rounds-title": "Progress Across Rounds",
   "progress-across-rounds-description-text": "Where the cohort landed this round at section level, and how each organization has moved since the previous round — who improved, who declined, and by how much.",
   "action-plan-status-title": "Action Plan Status",
   "action-plan-status-description-text": "Task completion per organization for the selected round, and how it relates to target attainment.",
   "score-band-deficient": "Deficient",
   "score-band-insufficient": "Insufficient",
   "score-band-satisfactory": "Satisfactory",
   "score-band-very-good": "Very Good",
   "score-band-excellent": "Excellent",
   "module-rejected-success-description": "Module rejected successfully",
   "failed-reject-module-description": "Failed to reject this module",
   "module-accepted-success-description": "Module accepted successfully",
   "failed-accept-module-description": "Failed to accept this module",
   "module-requests-title": "Module requests",
   "pending-modules-review-description-text": "This is the list of modules pending your review. To proceed, please click on each module where you'll be able to either accept or reject it.",

   // Login / Registration pages
   "welcome-back-title": "Welcome back!",
   "login-into-account-subtitle": "Login into your account",
   "email-placeholder": "yourmail@gmail.com",
   "password-label": "Password",
   "toggle-password-visibility-label": "Toggle password visibility",
   "remember-me-label": "Remember me?",
   "log-in-button": "Log in",
   "no-account-yet-text": "Don't have an account yet?",
   "sign-up-link": "Sign up",
   "max-16-symbols-validation": "Maximum 16 symbols",
   "go-back-icon-alt": "Go back",
   "go-back-to-login-link": "Go back to login",
   "welcome-to-kaporg-title": "Welcome to KAPorg!",
   "which-profile-title": "Which profile describes you best?",
   "profile-organization-label": "Organization",
   "profile-donors-label": "Donors",
   "profile-expert-label": "Expert",
   "signup-role-title": "How will you use KAPorg?",
   "signup-role-subtitle": "Choose the role that best matches your responsibilities.",
   "profile-donor-label": "Donor",
   "signup-role-organization-description": "Build Sustainable Organizational Capacity",
   "signup-role-donor-description": "Oversee Institutional Portfolio Performance",
   "signup-role-expert-description": "Deliver Independent Strategic Guidance",
   "signup-create-account-as-an": "Create an account as an",
   "signup-create-account-as-a": "Create an account as a",
   "showcase-login-headline": "We empower organizations to lead [[capacity development]]",
   "showcase-organization-headline": "Assess your capabilities and [[amplify your mission]]",
   "showcase-donor-headline": "Oversee portfolio performance and [[drive measurable results]]",
   "showcase-expert-headline": "Deliver strategic guidance and [[elevate institutional capacity]]",
   "signup-step-profile": "Profile",
   "signup-step-expertise": "Expertise",
   "profile-details-title": "Profile details",
   "upload-photo-text": "Upload photo",
   "adjust-your-photo-title": "Adjust your photo",
   "change-photo-text": "Change photo",
   "signup-step-account": "Account",
   "signup-step-contact": "Contact",
   "enter-organization-email-placeholder": "Enter organization's email",
   "code-must-have-6-digits-validation": "Code must have 6 digits",
   "code-incorrect-text": "The code is incorrect",
   "confirmation-email-shortly-text": "You will receive a confirmation email shortly",
   "go-to-homepage-button": "Go to homepage",
   "didnt-get-email-text": "Didn't get the email? Check your spam folder or write to",
   "language-selector-label": "Select language",
   "auth-tagline-transforming-title": "Transforming capacity building",
   "auth-tagline-transforming-description": "For the digital age",
   "auth-tagline-elevate-title": "Elevate your organization",
   "auth-tagline-elevate-description": "with purposeful evaluation!",
   "auth-tagline-changemakers-title": "Connect with the changemakers",
   "auth-tagline-changemakers-description": "who need you most.",
   "auth-tagline-miss-you-title": "We'll miss you,",
   "auth-tagline-miss-you-description": "We hope to welcome you back soon.",
   "auth-tagline-collaborations-title": "Dive into a world of",
   "auth-tagline-collaborations-description": "impactful collaborations!",
   "auth-tagline-expertise-title": "Your expertise",
   "auth-tagline-expertise-description": "and insights fuels Progress!",

   // National organization registration form
   "go-back-to-profile-selection-link": "Go back to profile selection",
   "create-account-title": "Create an account",
   "as-an-org-label": "as an Org",
   "login-details-title": "Login details",
   "confirm-password-label": "Confirm password",
   "type-description-placeholder": "Type description",
   "working-sectors-label": "Working sectors",
   "enter-organization-name-placeholder": "Enter organization's name",
   "enter-organization-address-placeholder": "Enter organization's address",
   "enter-organization-zip-code-placeholder": "Enter organization's zip code",
   "terms-agreement-prefix-text": "I have read and agreed with the",
   "terms-of-service-privacy-policy-link": "Terms of Service, Privacy Policy",
   "and-conjunction-text": "and",
   "cookie-policy-link": "Cookie Policy.",
   "invalid-email-address-validation": "Invalid email address",
   "password-min-length-validation": "Password must be at least 8 characters",
   "password-complexity-validation": "Password must contain at least one uppercase letter, one number and one of the specified symbols !, @, #, $, %, ^, &, *",
   "password-required-validation": "Password is required",
   "passwords-must-match-validation": "Passwords must match",
   "confirm-password-required-validation": "Confirm Password is required",
   "organization-name-required-validation": "International Organization's name is required",
   "foundation-year-required-validation": "Foundation year is required",
   "sectors-min-validation": "At least one sector must be selected",
   "sectors-required-validation": "Sectors are required",
   "organization-address-required-validation": "Organization address is required",
   "invalid-organization-email-validation": "Invalid organization email",
   "organization-email-required-validation": "Organization's email is required",
   "accept-terms-required-validation": "You must accept the terms and conditions",

   // Donor registration form
   "as-an-international-donor-label": "as an International donor",
   "donor-organization-name-required-validation": "Organization Name is required",
   "invitation-code-label": "Invitation code",
   "enter-invitation-code-placeholder": "Enter your invitation code",
   "invitation-code-min-length-validation": "Invitation code must be at least 12 characters",
   "invitation-code-required-validation": "Invitation Code is required",
   "invalid-invitation-code-format-validation": "Invalid invitation code format",
   "no-invitation-code-help-text": "If you don't have an invitation code please send us an email here:",

   // Terms/Conditions modal
   "close-icon-alt": "Close",
   "terms-of-service-tab-label": "Terms of service",
   "privacy-policy-tab-label": "Privacy policy",
   "cookie-policy-tab-label": "Cookie policy",
   "got-it-button": "Got it!",

   // Shared auth thunk toasts (donor/expert registration)
   "account-created-success-description": "Account created successfully.",
   "unexpected-error-description": "An unexpected error occurred. Please try again.",
   "verification-code-sent-description": "A verification code has been sent to your email.",
   "expert-user-created-success-description": "Expert user created successfully",

   // Expert registration step one
   "as-an-expert-label": "as an Expert",

   // Expert registration step three
   "lets-start-profile-info-title": "Let's start with your profile information",
   "enter-full-name-placeholder": "Enter your full name",
   "personal-statement-label": "Personal statement/motivation",
   "enter-personal-statement-placeholder": "Enter your personal statement",
   "select-nationality-placeholder": "Select your nationality",
   "select-country-of-residence-placeholder": "Select your country of residence",
   "operating-countries-label": "Operating countries",
   "enter-linkedin-profile-placeholder": "Enter your LinkedIn profile",
   "full-name-required-validation": "Full name is required",
   "nationality-required-validation": "Nationality is required",
   "country-of-residence-required-validation": "Country of residence is required",

   // Expert registration step four
   "now-your-professional-details-title": "Now your professional details",
   "profile-picture-label": "Profile Picture",
   "education-section-title": "Education",
   "select-highest-degree-placeholder": "Select your highest degree obtained",
   "enter-fields-of-study-placeholder": "Enter the fields of study",
   "enter-educational-institution-placeholder": "Enter your educational institution",
   "area-label": "Area",
   "enter-area-placeholder": "Enter the area",
   "add-another-area-button": "Add another area",
   "level-label": "Level",
   "select-level-placeholder": "Select level",
   "add-another-language-button": "Add another language",
   "upload-cv-label": "Upload your CV",
   "upload-certificate-label": "Upload a certification or a special training",
   "remove-button": "Remove",
   "image-file-type-badge": "JPG or PNG",
   "pdf-file-type-badge": "PDF",
   "highest-degree-required-validation": "Highest degree is required",
   "area-required-validation": "Area is required",
   "years-of-experience-required-validation": "Years of experience is required",
   "years-of-experience-number-validation": "Years of experience must be a number",
   "profile-picture-required-validation": "Profile picture is required",
   "invalid-image-file-type-validation": "Invalid file type. Only PNG or JPEG are allowed.",
   "file-size-too-large-validation": "File size is too large. Max size is 20MB.",
   "invalid-pdf-file-type-validation": "Invalid file type. Only PDF is allowed.",
   "level-required-validation": "Level is required",
   "level-number-validation": "Level must be a number",
   "go-back-to-profile-details-link": "Go back to profile details",
   "uploaded-file-icon-alt": "File",
   "add-icon-alt": "Add",

   // Confirm-code page
   "verification-code-title": "Verification code",
   "verification-code-sent-to-text": "Please enter the verification code that we sent to",
   "verify-code-button": "Verify code",
   "didnt-receive-code-text": "If you didn't receive a verification code,",
   "resend-code-link": "click here to resend it",
   "or-send-email-at-text": "or send us an email at",
   "verification-code-required-validation": "Verification code is required",
   "code-verified-success-description": "Code verified successfully",

   // Account on review page
   "account-on-review-icon-alt": "Account under review",
   "got-your-application-title": "We've got your application!",
   "application-review-description-text": "You will receive a confirmation email once an administrator approves your request.",
   "in-the-meantime-prefix-text": "In the meantime, check out",
   "in-the-meantime-suffix-text": "for more info.",
   "thank-you-for-interest-text": "Thank you for your interest in KAPorg!",

   // Resources library
   "resources-library-tab-label": "Resources library",
   "resource-type-all-label": "All resources",
   "resource-type-documents-label": "Documents",
   "resource-type-videos-label": "Videos",
   "resource-type-links-label": "Links",
   "resource-type-presentations-label": "Presentations",
   "no-resources-available-text": "No resources available",
   "no-collections-available-text": "No collections available",
   "which-resource-looking-for-label": "Which one are you looking for?",
   "search-ellipsis-placeholder": "Search...",
   "assessments-placeholder": "Assessments",
   "modules-label": "Modules",
   "section-label": "Section",
   "sections-placeholder": "Sections",
   "resource-icon-alt": "Resources",
   "copy-link-action": "Copy link",
   "edit-resource-icon-alt": "Edit resource",
   "rate-this-resource-action": "Rate this resource",
   "delete-resource-icon-alt": "Delete resource",
   "more-suffix-text": "more",
   "rate-this-resource-title": "Rate this Resource",
   "resource-word": "Resource",
   "your-rating-label": "Your rating:",
   "save-rating-button": "Save rating",
   "all-tab-label": "All",
   "my-collections-label": "Collections",
   "my-collection-toggle-label": "My collection",
   "all-collections-label": "Collections",
   "edit-collection-icon-alt": "Edit collection",
   "delete-collection-icon-alt": "Delete collection",
   "preview-colon-label": "Preview:",
   "resources-word": "Resources",

   // Top navigation bar: account/user menu (PopoverLinks)
   "account-summary-icon-alt": "account summary",
   "account-summary-label": "Account summary",
   "account-summary-upgrade-message":
      "You're reaching your package limit. Upgrade it to have more space and create without limits.",
   "upgrade-package-button": "Upgrade package",
   "modules-available-label": "Modules available",
   "modules-created-label": "Modules created",
   "assessments-available-label": "Assessments available",
   "assessments-created-label": "Assessments created",
   "workspaces-available-label": "Workspaces available",
   "workspaces-created-label": "Workspaces created",
   "including-humanitarian-experts-created-label": "including humanitarian experts created",
   "amount-of-storage-label": "Amount of storage",
   "data-usage-label": "Data usage",
   "usage-statistics-label": "Usage statistics",
   "available-label": "Available",
   "used-label": "Used",
   "profile-info-icon-alt": "profile info",
   "profile-information-label": "Profile information",
   "login-info-icon-alt": "login info",
   "login-information-label": "Login information",
   "payment-info-icon-alt": "payment info",
   "payment-information-label": "Payment information",
   "log-out-icon-alt": "log out",
   "log-out-button": "Log out",
   "account-menu-toggle-alt": "Account menu",

   // Top navigation bar: mobile header
   "menu-toggle-icon-alt": "Menu",
   "logo-alt-text": "Logo",

   // Top navigation bar: notifications popover
   "mark-all-as-read-button": "Mark all as read",
   "unread-tab-label": "Unread",
   "no-notifications-title-text": "No notifications here!",
   "up-to-date-description-text": "Everything is up-to-date!",

   // Terms of Service (legal document body)
   "terms-last-updated-text": "These Terms of Service were last updated on March 4, 2024.",
   "terms-intro-websites-prefix-text": "These Terms of Service govern your use of our websites located at",
   "terms-intro-websites-suffix-text": ", as well as any related services provided by International Advisory, Products and Systems Ltd. By accessing our websites you agree to abide by these Terms of Service and to comply with all applicable laws and regulations. If you do not agree with these Terms of Service, you are prohibited from using or accessing those websites or using any other services provided by International Advisory, Products and Systems Ltd. We, International Advisory, Products and Systems Ltd, reserve the right to review and amend any of these Terms of Service at our sole discretion. Upon doing so, we will update this page. Any changes to these Terms of Service will take effect immediately from the date of publication.",
   "overview-of-services-title": "Overview of Services",
   "overview-of-services-description-text": "International Advisory, Products and Systems Ltd. (i-APS), together with its affiliated entities, including but not limited to KAPsurvey, KAPorg, KAPinsights, and KAPcourse (hereinafter collectively referred to as “KAPtech Group”), provides technical advisory services, innovative technological solutions, and comprehensive data collection and analysis tools. The offerings of KAPtech Group are aimed at supporting the execution and management of expert and development projects. These services utilize cutting-edge technology and capitalize on extensive local expertise to assist partner organizations and communities in effectively responding to and overcoming challenges in expert aid and development sectors. By using the services provided by KAPtech Group, including accessing our websites, you agree to comply with and be bound by the terms and conditions set forth in this agreement. The services offered are subject to the terms outlined herein, along with any additional guidelines or rules applicable to specific services or features of the services.",
   "limitations-of-use-title": "Limitations of Use",
   "limitations-of-use-intro-text": "By using our websites, you warrant on behalf of yourself, your users, and other parties you represent that you will not:",
   "limitation-modify-content-text": "modify, copy, prepare derivative works of, decompile, or reverse engineer any materials and software contained on those websites;",
   "limitation-remove-notices-text": "remove any copyright or other proprietary notations from any materials and software on those websites;",
   "limitation-transfer-materials-text": "transfer the materials to another person or \"mirror\" the materials on any other server;",
   "limitation-abuse-networks-text": "knowingly or negligently use those websites or any of their associated services in a way that abuses or disrupts our networks or any other service International Advisory, Products and Systems Ltd provides;",
   "limitation-unlawful-material-text": "use those websites or their associated services to transmit or publish any harassing, indecent, obscene, fraudulent, or unlawful material;",
   "limitation-violate-laws-text": "use those websites or their associated services in violation of any applicable laws or regulations;",
   "limitation-spam-text": "use those websites in conjunction with sending unauthorized advertising or spam;",
   "limitation-harvest-data-text": "harvest, collect, or gather user data without the user’s consent; or",
   "limitation-infringe-rights-text": "use those websites or their associated services in such a way that may infringe the privacy, intellectual property rights, or other rights of third parties",
   "intellectual-property-title": "Intellectual Property",
   "intellectual-property-description-text": "The intellectual property in the materials contained in those websites are owned by or licensed to International Advisory, Products and Systems Ltd and are protected by applicable copyright and trademark law. We grant our users permission to download one copy of the materials for personal, non-commercial transitory use. This constitutes the grant of a license, not a transfer of title. This license shall automatically terminate if you violate any of these restrictions or the Terms of Service, and may be terminated by International Advisory, Products and Systems Ltd at any time.",
   "user-generated-content-title": "User-Generated Content",
   "terms-user-generated-content-description-text": "You retain your intellectual property ownership rights over the content you submit to us for publication on our websites. We will never claim ownership of your content, but we do require a license from you in order to use it. When you use our websites or their associated services to post, upload, share, or otherwise transmit content covered by intellectual property rights, you grant to us a non-exclusive, royalty-free, transferable, sub-licensable, worldwide license to use, distribute, modify, run, copy, publicly display, translate, or otherwise create derivative works of your content in a manner that is consistent with your privacy preferences and our Privacy Policy. The license you grant us can be terminated at any time by deleting your content or account. However, to the extent that we (or our partners) have used your content in connection with commercial or sponsored content, the license will continue until the relevant commercial or post has been discontinued by us. You give us permission to use your username and other identifying information associated with your account in a manner that is consistent with your privacy preferences and our Privacy Policy.",
   "registration-and-payments-title": "Registration and Payments",
   "registration-and-payments-description-text": "In order to use any of our services, you need to create an account. Any information provided needs to be accurate and updated if necessary. Customers are liable for maintaining their accounts and are fully responsible for all activities occurring under their accounts. Should anybody gain unauthorized access to your account, you need to notify us immediately. International Advisory, Products and Systems Ltd is not liable for any loss or damage arising from failure to maintain the confidentiality of your account. When creating your account, you are required to provide your financial information relevant to the chosen payment method. In some cases, you may be requested to provide your credit card details. Please note that any payments made on our platform will be processed by PayPal, Stripe, Square, Google Payments, or Apple Pay. As such, we will not be responsible for processing or retaining any of your financial information. PayPal, Stripe, Square, Google Payments, or Apple Pay will handle all of your financial information per their respective Terms of Service, and you agree to comply with such Terms of Service.",
   "disclaimer-and-limitations-title": "Disclaimer and Limitations of Liability",
   "disclaimer-websites-prefix-text": "The websites and materials provided by International Advisory, Products and Systems Ltd., including but not limited to",
   "disclaimer-as-is-description-text": ", are made available to users on an 'as is' basis. International Advisory, Products and Systems Ltd disclaims all warranties, express or implied, to the extent permitted by law. This includes but is not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement of intellectual property rights. Furthermore, no advice or information, whether oral or written, obtained by you from International Advisory, Products and Systems Ltd or through the services shall create any warranty not expressly stated in these terms. International Advisory, Products and Systems Ltd and its suppliers shall not be liable for any direct, indirect, incidental, special, consequential, or exemplary damages, including but not limited to damages for loss of profits, goodwill, use, data, or other intangible losses (even if International Advisory, Products and Systems Ltd has been advised of the possibility of such damages), resulting from the use or the inability to use the services or any other matter relating to the services. This limitation of liability applies whether the alleged liability is based on contract, tort, negligence, strict liability, or any other basis, even if International Advisory, Products and Systems Ltd has been advised of the possibility of such damage. Given the nature of the services provided by International Advisory, Products and Systems Ltd, especially in the context of expert and development sectors, users acknowledge the inherent risks involved in data collection and the use of technology-driven solutions. Users are solely responsible for ensuring their compliance with all applicable laws and regulations, including but not limited to data protection and privacy laws. The responsibility for obtaining the necessary consents and permissions for data collection, particularly when involving minors or sensitive data, rests with the user. The liability of International Advisory, Products and Systems Ltd and its affiliates, directors, officers, employees, agents, suppliers, and licensors is limited to the maximum extent permitted by law. If you are dissatisfied with any portion of the services, or with any of these terms, your sole and exclusive remedy is to discontinue using the services. Some jurisdictions do not allow the exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages, so some of the above limitations may not apply to you.",
   "accuracy-of-materials-title": "Accuracy of Materials",
   "accuracy-of-materials-description-text": "The materials appearing on our websites are not comprehensive and are for general information purposes only. International Advisory, Products and Systems Ltd does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on those websites, or otherwise relating to such materials or on any resources linked to those websites. You should not rely solely on the said materials to make decisions, we advise you to consult other, more complete sources of information. You are solely responsible for the strict reliance on the materials posted on our websites. We have the right to change the information on our websites without prior notice and users are responsible to monitor said changes.",
   "additional-tools-title": "Additional Tools",
   "additional-tools-description-text": "Please note that our websites may include third-party tools which are outside of our control. The access to said tools is provided on an 'as is' basis with no warranties, expressed or implied, and without any endorsement. We are not liable for the use of the third-party tools provided on our websites. You are solely responsible for any risks associated with using said tools, we recommend reading the relevant third-party provider’s Terms of Service. International Advisory, Products and Systems Ltd has the right to offer new third-party tools in the future",
   "links-title": "Links",
   "links-description-text": "International Advisory, Products and Systems Ltd has not reviewed all of the sites linked to its websites and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement, approval or control by International Advisory, Products and Systems Ltd of the site. Use of any such linked site is at your own risk, and we strongly advise you make your own investigations with respect to the suitability of those sites.",
   "inaccuracies-and-mistakes-title": "Inaccuracies and Mistakes",
   "inaccuracies-and-mistakes-description-text": "Please note that any content available on our websites may contain typographical errors, inaccuracies, or mistakes related to the service’s description, pricing, promotion, and availability. We have the right to cancel or update any existing services should any information provided by us be proven inaccurate. Said information can be amended at any time without prior notice. Please note that we are not obligated to clarify any of the information related to our websites and services, including pricing information, except as required by law.",
   "indemnification-title": "Indemnification",
   "indemnification-description-text": "You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: (1) your Contributions; (2) use of the websites; (3) breach of these Terms of Service; (4) any breach of your representations and warranties set forth in these Terms of Service; (5) your violation of the rights of a third party, including but not limited to intellectual property rights; or (6) any overt harmful act toward any other user of the websites with whom you connected via the websites.",
   "indemnification-defense-text": "Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it.",
   "right-to-terminate-title": "Right to Terminate",
   "right-to-terminate-description-text": "We may suspend or terminate your right to use our websites and terminate these Terms of Service immediately upon written notice to you for any breach of these Terms of Service.",
   "severance-title": "Severance",
   "severance-description-text": "Any term of these Terms of Service which is wholly or partially void or unenforceable is severed to the extent that it is void or unenforceable. The validity of the remainder of these Terms of Service is not affected.",
   "entire-agreement-title": "Entire Agreement",
   "entire-agreement-description-text": "These Terms of Service and any policies or operating rules posted by us on the websites or with respect to the websites constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Service shall not operate as a waiver of such right or provision. These Terms of Service operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control. If any provision or part of a provision of these Terms of Service is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Terms of Service and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment, or agency relationship created between you and us as a result of these Terms of Service or use of the websites. You agree that these Terms of Service will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Service and the lack of signing by the parties hereto to execute these Terms of Service.",
   "governing-law-title": "Governing Law",
   "governing-law-description-text": "These Terms of Service are governed by and construed in accordance with the laws of Virginia. You irrevocably submit to the exclusive jurisdiction of the courts in that State or location.",

   // Privacy Policy (legal document body)
   "privacy-last-updated-text": "These Terms of Service were last updated on March 4, 2024.",
   "privacy-intro-websites-prefix-text": "Your privacy is important to us. It is International Advisory, Products and Systems Ltd's policy to respect your privacy and comply with any applicable law and regulation regarding any personal information we may collect about you, including across our websites,",
   "privacy-intro-websites-suffix-text": ", and other sites we own and operate.",
   "personal-information-definition-text": "Personal information is any information about you which can be used to identify you. This includes information about you as a person (such as name, address, and date of birth), your devices, payment details, and even information about how you use a website or online service.",
   "third-party-sites-disclaimer-text": "In the event our sites contain links to third-party sites and services, please be aware that those sites and services have their own privacy policies. After following a link to any third-party content, you should read their posted privacy policy information about how they collect and use personal information. This Privacy Policy does not apply to any of your activities after you leave one of our sites.",
   "information-we-collect-title": "Information We Collect",
   "information-categories-intro-text": "Information we collect falls into one of two categories: “voluntarily provided” information and “automatically collected” information",
   "voluntarily-provided-info-description-text": "“Voluntarily provided” information refers to any information you knowingly and actively provide us when using or participating in any of our services and promotions.",
   "automatically-collected-info-description-text": "“Automatically collected” information refers to any information automatically sent by your devices in the course of accessing our products and services.",
   "log-data-title": "Log Data",
   "log-data-description-text": "When you visit one of our websites, our servers may automatically log the standard data provided by your web browser. It may include your device’s Internet Protocol (IP) address, your browser type and version, the pages you visit, the time and date of your visit, the time spent on each page, and other details about your visit.",
   "log-data-errors-description-text": "Additionally, if you encounter certain errors while using our sites, we may automatically collect data about the error and the circumstances surrounding its occurrence. This data may include technical details about your device, what you were trying to do when the error happened, and other technical information relating to the problem. You may or may not receive notice of such errors, even in the moment they occur, that they have occurred, or what the nature of the error is.",
   "log-data-combination-warning-text": "Please be aware that while this information may not be personally identifying by itself, it may be possible to combine it with other data to personally identify individual persons.",
   "device-data-title": "Device Data",
   "device-data-intro-text": "When you visit our websites or interact with our services, we may automatically collect data about your device, such as:",
   "device-type-label": "Device type",
   "operating-system-label": "Operating system",
   "unique-device-identifiers-label": "Unique device identifiers",
   "geo-location-data-label": "Geo-location data",
   "device-data-settings-note-text": "Data we collect can depend on the individual settings of your device and software. We recommend checking the policies of your device manufacturer or software provider to learn what information they make available to us.",
   "personal-information-title": "Personal Information",
   "personal-information-intro-text": "We may ask for personal information — for example, when you subscribe to our newsletter or when you contact us — which may include one or more of the following:",
   "social-media-profiles-label": "Social media profiles",
   "date-of-birth-label": "Date of birth",
   "phone-mobile-number-label": "Phone/mobile number",
   "home-mailing-address-label": "Home/mailing address",
   "work-related-information-label": "Work-related information",
   "company-name-label": "Company name",
   "title-field-label": "Title",
   "sensitive-information-title": "Sensitive Information",
   "sensitive-information-definition-text": "“Sensitive information” or “special categories of data” is a subset of personal information that is given a higher level of protection. Examples of sensitive information include information relating to your racial or ethnic origin, political opinions, religion, trade union or other professional associations or memberships, philosophical beliefs, sexual orientation, sexual practices or sex life, criminal records, health information, or biometric information.",
   "sensitive-information-types-intro-text": "The types of sensitive information that we may collect about you include:",
   "sensitive-information-consent-text": "We will not collect sensitive information about you without first obtaining your consent, and we will only use or disclose your sensitive information as permitted, required, or authorized by law.",
   "privacy-user-generated-content-description-text": "We consider “user-generated content” to be materials (text, image and/or video content) voluntarily supplied to us by our users for the purpose of publication, processing, or usage on our platform. All user-generated content is associated with the account or email address used to submit the materials.",
   "user-generated-content-publication-notice-text": "Please be aware that any content you submit for the purpose of publication will be public after posting (and subsequent review or vetting process). Once published, it may be accessible to third parties not covered under this privacy policy.",
   "transaction-data-title": "Transaction Data",
   "transaction-data-description-text": "Transaction data refers to data that accumulates over the normal course of operation on our platform. This may include transaction records, stored files, user profiles, analytics data and other metrics, as well as other types of information, created or generated, as users interact with our services.",
   "legitimate-reasons-title": "Legitimate Reasons for Processing Your Personal Information",
   "legitimate-reasons-description-text": "We only collect and use your personal information when we have a legitimate reason for doing so. In which instance, we only collect personal information that is reasonably necessary to provide our services to you.",
   "collection-and-use-title": "Collection and Use of Information",
   "collection-and-use-intro-text": "We may collect personal information from you when you do any of the following on our websites:",
   "collect-register-account-text": "Register for an account",
   "collect-purchase-subscription-text": "Purchase a subscription",
   "collect-signup-updates-text": "Sign up to receive updates from us via email or social media channels",
   "collect-mobile-browser-text": "Use a mobile device or web browser to access our content",
   "collect-contact-us-text": "Contact us via email, social media, or on any similar technologies",
   "collect-social-media-mention-text": "When you mention us on social media",
   "collection-purposes-intro-text": "We may collect, hold, use, and disclose information for the following purposes, and personal information will not be further processed in a manner that is incompatible with these purposes:",
   "purpose-core-features-text": "to provide you with our platform's core features and services",
   "purpose-customize-experience-text": "to enable you to customize or personalize your experience of our websites",
   "purpose-deliver-products-text": "to deliver products and/or services to you",
   "purpose-contact-communicate-text": "to contact and communicate with you",
   "purpose-analytics-research-text": "for analytics, market research, and business development, including to operate and improve our websites, associated applications, and associated social media platforms",
   "purpose-advertising-marketing-text": "for advertising and marketing, including to send you promotional information about our products and services and information about third parties that we consider may be of interest to you",
   "purpose-enable-access-text": "to enable you to access and use our websites, associated applications, and associated social media platforms",
   "purpose-record-keeping-text": "for internal record keeping and administrative purposes",
   "purpose-legal-compliance-text": "to comply with our legal obligations and resolve any disputes that we may have",
   "purpose-attribute-content-text": "to attribute any content (e.g. posts and comments) you submit that we publish on our websites",
   "purpose-security-fraud-text": "for security and fraud prevention, and to ensure that our sites and apps are safe, secure, and used in line with our terms of use",
   "purpose-technical-assessment-text": "for technical assessment, including to operate and improve our app, associated applications, and associated social media platforms",
   "collection-combine-sources-text": "We may combine voluntarily provided and automatically collected personal information with general information or research data we receive from other trusted sources. For example, If you provide us with your location, we may combine this with general information about currency and language to provide you with an enhanced experience of our sites and service.",
   "security-of-information-title": "Security of Your Personal Information",
   "security-measures-description-text": "When we collect and process personal information, and while we retain this information, we will protect it within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure, copying, use or modification.",
   "security-no-guarantee-text": "Although we will do our best to protect the personal information you provide to us, we advise that no method of electronic transmission or storage is 100% secure and no one can guarantee absolute data security.",
   "security-password-responsibility-text": "You are responsible for selecting any password and its overall security strength, ensuring the security of your own information within the bounds of our services. For example, ensuring any passwords associated with accessing your personal information and accounts are secure and confidential.",
   "retention-period-title": "How Long We Keep Your Personal Information",
   "retention-period-description-text": "We keep your personal information only for as long as we need to. This time period may depend on what we are using your information for, in accordance with this privacy policy. For example, if you have provided us with personal information as part of creating an account with us, we may retain this information for the duration your account exists on our system. If your personal information is no longer required for this purpose, we will delete it or make it anonymous by removing all details that identify you.",
   "retention-legal-obligation-text": "However, if necessary, we may retain your personal information for our compliance with a legal, accounting, or reporting obligation or for archiving purposes in the public interest, scientific, or historical research purposes or statistical purposes.",
   "childrens-privacy-title": "Children’s Privacy",
   "childrens-privacy-description-text": "We do not aim any of our products or services directly at children under the age of 13 and we do not knowingly collect personal information about children under 13.",
   "disclosure-to-third-parties-title": "Disclosure of Personal Information to Third Parties",
   "disclosure-intro-text": "We may disclose personal information to:",
   "disclose-affiliate-text": "a parent, subsidiary or affiliate of our company",
   "disclose-service-providers-text": "third-party service providers for the purpose of enabling them to provide their services, including (without limitation) IT service providers, data storage, hosting and server providers,ad networks,analytics,error loggers, debt collectors, maintenance or problem-solving providers,marketingoradvertisingproviders,professional advisors, and payment systems operators",
   "disclose-employees-text": "our employees, contractors, and/or related entities",
   "disclose-business-partners-text": "our existing or potential agents or business partners",
   "disclose-credit-agencies-text": "credit reporting agencies, courts, tribunals, and regulatory authorities, in the event you fail to pay for goods or services we have provided to you",
   "disclose-law-enforcement-text": "courts, tribunals, regulatory authorities, and law enforcement officers, as required by law, in connection with any actual or prospective legal proceedings, or in order to establish, exercise, or defend our legal rights",
   "disclose-agents-subcontractors-text": "third parties, including agents or sub-contractors who assist us in providing information, products, services, or direct marketing to you",
   "disclose-collect-process-text": "third parties to collect and process data",
   "disclose-business-transfer-text": "an entity that buys, or to which we transfer all or substantially all of our assets and business",
   "third-parties-currently-used-text": "Third parties we currently use include:",
   "international-transfers-title": "International Transfers of Personal Information",
   "international-transfers-description-text": "The personal information we collect is stored and/or processed in United States, or where we or our partners, affiliates, and third-party providers maintain facilities.",
   "international-transfers-legal-note-text": "The countries to which we store, process, or transfer your personal information may not have the same data protection laws as the country in which you initially provided the information. If we transfer your personal information to third parties in other countries: (i) we will perform those transfers in accordance with the requirements of applicable law; and (ii) we will protect the transferred personal information in accordance with this privacy policy.",
   "your-rights-title": "Your Rights and Controlling Your Personal Information",
   "your-choice-description-text": "Your choice: By providing personal information to us, you understand we will collect, hold, use, and disclose your personal information in accordance with this privacy policy. You do not have to provide personal information to us, however, if you do not, it may affect your use of our websites or the products and/or services offered on or through them.",
   "info-from-third-parties-text": "Information from third parties: If we receive personal information about you from a third party, we will protect it as set out in this privacy policy. If you are a third party providing personal information about somebody else, you represent and warrant that you have such person’s consent to provide the personal information to us",
   "marketing-permission-text": "Marketing permission: If you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by contacting us using the details below.",
   "access-rights-text": "Access: You may request details of the personal information that we hold about you",
   "correction-rights-text": "Correction: If you believe that any information we hold about you is inaccurate, out of date, incomplete, irrelevant, or misleading, please contact us using the details provided in this privacy policy. We will take reasonable steps to correct any information found to be inaccurate, incomplete, misleading, or out of date.",
   "non-discrimination-text": "Non-discrimination: We will not discriminate against you for exercising any of your rights over your personal information. Unless your personal information is required to provide you with a particular service or offer (for example processing transaction data), we will not deny you goods or services and/or charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties, or provide you with a different level or quality of goods or services.",
   "download-personal-info-text": "Downloading of Personal Information: We provide a means for you to download the personal information you have shared through our sites. Please contact us for more information.",
   "data-breach-notification-text": "Notification of data breaches: We will comply with laws applicable to us in respect of any data breach.",
   "complaints-rights-text": "Complaints: If you believe that we have breached a relevant data protection law and wish to make a complaint, please contact us using the details below and provide us with full details of the alleged breach. We will promptly investigate your complaint and respond to you, in writing, setting out the outcome of our investigation and the steps we will take to deal with your complaint. You also have the right to contact a regulatory body or data protection authority in relation to your complaint.",
   "unsubscribe-rights-text": "Unsubscribe: To unsubscribe from our email database or opt-out of communications (including marketing communications), please contact us using the details provided in this privacy policy, or opt-out using the opt-out facilities provided in the communication. We may need to request specific information from you to help us confirm your identity.",
   "use-of-cookies-title": "Use of Cookies",
   "use-of-cookies-description-text": "We use \"cookies\" to collect information about you and your activity across our sites. A cookie is a small piece of data that our websites store on your computer, and access each time you visit, so we can understand how you use our sites. This helps us serve you content based on preferences you have specified.",
   "refer-to-cookie-policy-text": "Please refer to our Cookie Policy for more information.",
   "business-transfers-title": "Business Transfers",
   "business-transfers-description-text": "If we or our assets are acquired, or in the unlikely event that we go out of business or enter bankruptcy, we would include data, including your personal information, among the assets transferred to any parties who acquire us. You acknowledge that such transfers may occur, and that any parties who acquire us may, to the extent permitted by applicable law, continue to use your personal information according to this policy, which they will be required to assume as it is the basis for any ownership or use rights we have over such information.",
   "limits-of-policy-title": "Limits of Our Policy",
   "limits-of-policy-description-text": "Our websites may link to external sites that are not operated by us. Please be aware that we have no control over the content and policies of those sites, and cannot accept responsibility or liability for their respective privacy practices.",
   "changes-to-policy-title": "Changes to This Policy",
   "changes-to-policy-description-text": "At our discretion, we may change our privacy policy to reflect updates to our business processes, current acceptable practices, or legislative or regulatory changes. If we decide to change this privacy policy, we will post the changes here at the same link by which you are accessing this privacy policy.",
   "changes-significant-notice-text": "If the changes are significant, or if required by applicable law, we will contact you (based on your selected preferences for communications from us) and all our registered users with the new details and links to the updated or changed policy.",
   "changes-permission-text": "If required by law, we will get your permission or give you the opportunity to opt in to or opt out of, as applicable, any new uses of your personal information.",
   "au-privacy-act-title": "Additional Disclosures for Australian Privacy Act Compliance (AU)",
   "au-privacy-act-description-text": "Where the disclosure of your personal information is solely subject to Australian privacy laws, you acknowledge that some third parties may not be regulated by the Privacy Act and the Australian Privacy Principles in the Privacy Act. You acknowledge that if any such third party engages in any act or practice that contravenes the Australian Privacy Principles, it would not be accountable under the Privacy Act, and you will not be able to seek redress under the Privacy Act.",
   "gdpr-compliance-title": "Additional Disclosures for General Data Protection Regulation (GDPR) Compliance (EU)",
   "data-controller-processor-title": "Data Controller / Data Processor",
   "data-controller-processor-description-text": "The GDPR distinguishes between organisations that process personal information for their own purposes (known as \"data controllers\") and organisations that process personal information on behalf of other organisations (known as \"data processors\"). We, International Advisory, Products and Systems Ltd, located at the address provided in our Contact Us section, are a Data Controller and/or Processor with respect to the personal information you provide to us.",
   "legal-bases-title": "Legal Bases for Processing Your Personal Information",
   "legal-bases-description-text": "We will only collect and use your personal information when we have a legal right to do so. In which case, we will collect and use your personal information lawfully, fairly, and in a transparent manner. If we seek your consent to process your personal information, and you are under 16 years of age, we will seek your parent or legal guardian’s consent to process your personal information for that specific purpose.",
   "legal-bases-grounds-text": "Our lawful bases depend on the services you use and how you use them. This means we only collect and use your information on the following grounds:",
   "consent-from-you-title": "Consent From You",
   "consent-from-you-description-text": "Where you give us consent to collect and use your personal information for a specific purpose. You may withdraw your consent at any time using the facilities we provide; however this will not affect any use of your information that has already taken place. You may consent to providing your email address for the purpose of receiving marketing emails from us. While you may unsubscribe at any time, we cannot recall any email we have already sent. If you have any further enquiries about how to withdraw your consent, please feel free to enquire using the details provided in the Contact Us section of this privacy policy",
   "performance-of-contract-title": "Performance of a Contract or Transaction",
   "performance-of-contract-description-text": "Where you have entered into a contract or transaction with us, or in order to take preparatory steps prior to our entering into a contract or transaction with you. For example, if you purchase a product, service, or subscription from us, we may need to use your personal and payment information in order to process and deliver your order.",
   "legitimate-interests-title": "Our Legitimate Interests",
   "legitimate-interests-description-text": "Where we assess it is necessary for our legitimate interests, such as for us to provide, operate, improve and communicate our services. We consider our legitimate interests to include research and development, understanding our audience, marketing and promoting our services, measures taken to operate our services efficiently, marketing analysis, and measures taken to protect our legal rights and interests.",
   "compliance-with-law-title": "Compliance with Law",
   "compliance-with-law-description-text": "In some cases, we may have a legal obligation to use or keep your personal information. Such cases may include (but are not limited to) court orders, criminal investigations, government requests, and regulatory obligations. If you have any further enquiries about how we retain personal information in order to comply with the law, please feel free to enquire using the details provided in the Contact Us section of this privacy policy.",
   "eea-transfers-title": "International Transfers Outside of the European Economic Area (EEA)",
   "eea-transfers-description-text": "We will ensure that any transfer of personal information from countries in the European Economic Area (EEA) to countries outside the EEA will be protected by appropriate safeguards, for example by using standard data protection clauses approved by the European Commission, or the use of binding corporate rules or other legally accepted means.",
   "restrict-processing-rights-text": "Restrict: You have the right to request that we restrict the processing of your personal information if (i) you are concerned about the accuracy of your personal information; (ii) you believe your personal information has been unlawfully processed; (iii) you need us to maintain the personal information solely for the purpose of a legal claim; or (iv) we are in the process of considering your objection in relation to processing on the basis of legitimate interests.",
   "objecting-to-processing-text": "Objecting to processing: You have the right to object to processing of your personal information that is based on our legitimate interests or public interest. If this is done, we must provide compelling legitimate grounds for the processing which overrides your interests, rights, and freedoms, in order to proceed with the processing of your personal information.",
   "data-portability-text": "Data portability: You may have the right to request a copy of the personal information we hold about you. Where possible, we will provide this information in CSV format or other easily readable machine format. You may also have the right to request that we transfer this personal information to a third party.",
   "deletion-rights-text": "Deletion: You may have a right to request that we delete the personal information we hold about you at any time, and we will take reasonable steps to delete your personal information from our current records. If you ask us to delete your personal information, we will let you know how the deletion affects your use of our websites or products and services. There may be exceptions to this right for specific legal reasons which, if applicable, we will set out for you in response to your request. If you terminate or delete your account, we will delete your personal information within 45 days of the deletion of your account. Please be aware that search engines and similar third parties may still retain copies of your personal information that has been made public at least once, like certain profile information and public comments, even after you have deleted the information from our services or deactivated your account.",
   "us-states-privacy-title": "Additional Disclosures for U.S. States Privacy Law Compliance.",
   "us-states-privacy-description-text": "The following section includes provisions that comply with the privacy laws of these states (California, Colorado, Delaware, Florida, Virginia, and Utah) and is applicable only to the residents of those states. Specific references to a particular state (in a heading or in the text) are only a reference to that state's law and applies only to that state's residents. Non-state specific language applies to all of the states listed above.",
   "do-not-track-title": "Do Not Track",
   "do-not-track-description-text": "Some browsers have a \"Do Not Track\" feature that lets you tell websites that you do not want to have your online activities tracked. At this time, we do not respond to browser \"Do Not Track\" signals.",
   "do-not-track-standards-text": "We adhere to the standards outlined in this privacy policy, ensuring we collect and process personal information lawfully, fairly, transparently, and with legitimate, legal reasons for doing so.",
   "cookies-and-pixels-title": "Cookies and Pixels",
   "cookies-and-pixels-description-text": "At all times, you may decline cookies from our sites if your browser permits. Most browsers allow you to activate settings on your browser to refuse the setting of all or some cookies. Accordingly, your ability to limit cookies is based only on your browser’s capabilities. Please refer to the Cookies section of this privacy policy for more information.",
   "california-privacy-laws-title": "California Privacy Laws - CPPA",
   "california-privacy-financial-incentive-text": "Under California Civil Code Section 1798.83, if you live in California and your business relationship with us is mainly for personal, family, or household purposes, you may ask us about the information we release to other organizations for their marketing purposes. In accordance with your right to non-discrimination, we may offer you certain financial incentives permitted by the California Consumer Privacy Act, and the California Privacy Rights Act (collectively, CCPA) that can result in different prices, rates, or quality levels for the goods or services we provide. Any CCPA-permitted financial incentive we offer will reasonably relate to the value of your personal information, and we will provide written terms that describe clearly the nature of such an offer. Participation in a financial incentive program requires your prior opt-in consent, which you may revoke at any time.",
   "california-privacy-request-info-text": "Under California Civil Code Section 1798.83, if you live in California and your business relationship with us is mainly for personal, family, or household purposes, you may ask us about the information we release to other organizations for their marketing purposes. To make such a request, please contact us using the details provided in this privacy policy with “Request for California privacy information” in the subject line. You may make this type of request once every calendar year. We will email you a list of categories of personal information we revealed to other organisations for their marketing purposes in the last calendar year, along with their names and addresses. Not all personal information shared in this way is covered by Section 1798.83 of the California Civil Code.",
   "california-notice-of-collection-title": "California Notice of Collection",
   "california-notice-of-collection-intro-text": "In the past 12 months, we have collected the following categories of personal information enumerated in the CCPA:",
   "ccpa-identifiers-text": "Identifiers, such as name, email address, phone number, account name, IP address, and an ID or number assigned to your account.",
   "ccpa-customer-records-text": "Customer records, such as billing and shipping address, and credit or debit card data.",
   "ccpa-demographics-text": "Demographics, such as your age or gender. This category includes data that may qualify as protected classifications under other California or federal laws.",
   "ccpa-commercial-info-text": "Commercial information, such as products or services history and purchases.",
   "ccpa-internet-activity-text": "Internet activity, such as your interactions with our service.",
   "ccpa-audio-visual-text": "Audio or visual data, such as photos or videos you share with us or post on the service.",
   "ccpa-geolocation-text": "Geolocation data.",
   "ccpa-employment-education-text": "Employment and education data, such as data you provide when you apply for a job with us.",
   "ccpa-inferences-text": "Inferences, such as information about your interests, preferences and favorites.",
   "california-notice-of-collection-outro-text": "For more information on information we collect, including the sources we receive information from, review the “Information We Collect” section. We collect and use these categories of personal information for the business purposes described in the “Collection and Use of Information” section, including to provide and manage our Service.",
   "right-to-know-delete-title": "Right to Know and Delete",
   "right-to-know-delete-intro-text": "You have rights to delete your personal information we collected and know certain information about our data practices in the preceding 12 months. In particular, you have the right to request the following from us:",
   "know-delete-categories-collected-text": "The categories of personal information we have collected about you;",
   "know-delete-categories-sources-text": "The categories of sources from which the personal information was collected;",
   "know-delete-categories-disclosed-text": "The categories of personal information about you we disclosed for a business purpose or sold;",
   "know-delete-third-parties-text": "The categories of third parties to whom the personal information was disclosed for a business purpose or sold;",
   "know-delete-business-purpose-text": "The business or commercial purpose for collecting or selling the personal information; and",
   "know-delete-specific-pieces-text": "The specific pieces of personal information we have collected about you.",
   "right-to-know-delete-outro-text": "To exercise any of these rights, please contact us using the details provided in this privacy policy.",
   "shine-the-light-title": "Shine the Light",
   "shine-the-light-description-text": "In addition to the rights discussed above, you have the right to request information from us regarding the manner in which we share certain personal information as defined by applicable statute with third parties and affiliates for their own direct marketing purposes.",
   "shine-the-light-request-text": "To receive this information, send us a request using the contact details provided in this privacy policy. Requests must include “Privacy Rights Request” in the first line of the description and include your name, street address, city, state, and ZIP code.",
   "contact-us-title": "Contact Us",
   "privacy-contact-us-description-text": "For any questions or concerns regarding your privacy, you may contact us using the following details:",
   "customer-service-label": "Customer Service",

   // Cookie Policy (legal document body)
   "cookie-last-updated-text": "These Terms of Service were last updated on March 4, 2024.",
   "cookie-intro-websites-prefix-text": "We use cookies to help improve your experience of our websites at",
   "cookie-intro-websites-suffix-text": ". This cookie policy is part of International Advisory, Products and Systems Ltd's privacy policy. It covers the use of cookies between your device and our sites.",
   "cookie-third-party-services-notice-text": "We also provide basic information on third-party services we may use, who may also use cookies as part of their service. This policy does not cover their cookies.",
   "cookie-refuse-prefix-text": "If you don't wish to accept cookies from us, you should instruct your browser to refuse cookies from",
   "cookie-refuse-suffix-text": ". In such a case, we may be unable to provide you with some of your desired content and services.",
   "what-is-a-cookie-title": "What is a cookie?",
   "cookie-definition-text": "A cookie is a small piece of data that a website stores on your device when you visit. It typically contains information about the website itself, a unique identifier that allows the site to recognise your web browser when you return, additional data that serves the cookie’s purpose, and the lifespan of the cookie itself.",
   "cookie-usage-examples-text": "Cookies are used to enable certain features (e.g. logging in), track site usage (e.g. analytics), store your user settings (e.g. time zone, notification preferences), and to personalize your content (e.g. advertising, language).",
   "first-party-cookies-definition-text": "Cookies set by the website you are visiting are usually referred to as first-party cookies. They typically only track your activity on that particular site.",
   "third-party-cookies-definition-text": "Cookies set by other sites and companies (i.e. third parties) are called third-party cookies They can be used to track you on other websites that use the same third-party service.",
   "cookie-types-title": "Types of cookies and how we use them",
   "essential-cookies-definition-text": "Essential cookies are crucial to your experience of a website, enabling core features like user logins, account management, shopping carts, and payment processing.",
   "essential-cookies-usage-text": "We use essential cookies to enable certain functions on our websites.",
   "performance-cookies-title": "Performance cookies",
   "performance-cookies-definition-text": "Performance cookies track how you use a website during your visit. Typically, this information is anonymous and aggregated, with information tracked across all site users. They help companies understand visitor usage patterns, identify and diagnose problems or errors their users may encounter, and make better strategic decisions in improving their audience’s overall website experience. These cookies may be set by the website you’re visiting (first-party) or by third-party services. They do not collect personal information about you.",
   "performance-cookies-usage-text": "We use performance cookies on our sites.",
   "functionality-cookies-title": "Functionality cookies",
   "functionality-cookies-definition-text": "Functionality cookies are used to collect information about your device and any settings you may configure on the website you’re visiting (like language and time zone settings). With this information, websites can provide you with customized, enhanced, or optimized content and services. These cookies may be set by the website you’re visiting (first-party) or by third-party services.",
   "functionality-cookies-usage-text": "We use functionality cookies for selected features on our sites.",
   "targeting-advertising-cookies-title": "Targeting/advertising cookies",
   "targeting-advertising-cookies-definition-text": "Targeting/advertising cookies help determine what promotional content is most relevant and appropriate to you and your interests. Websites may use them to deliver targeted advertising or limit the number of times you see an advertisement. This helps companies improve the effectiveness of their campaigns and the quality of content presented to you. These cookies may be set by the website you’re visiting (first-party) or by third-party services. Targeting/advertising cookies set by third-parties may be used to track you on other websites that use the same third-party service.",
   "targeting-advertising-cookies-usage-text": "We use targeting/advertising cookies on our sites.",
   "control-cookies-title": "How Can You Control Our Website's Use of Cookies?",
   "cookie-consent-manager-description-text": "You have the right to decide whether to accept or reject cookies on our websites. You can manage your cookie preferences in our Cookie Consent Manager. The Cookie Consent Manager allows you to select which categories of cookies you accept or reject. Essential cookies cannot be rejected as they are strictly necessary to provide you with the services on our websites.",
   "browser-settings-cookie-control-text": "You may also be able to set or amend your cookie preferences by managing your web browser settings. As each web browser is different, please consult the instructions provided by your web browser (typically in the \"help\" section). If you choose to refuse or disable cookies you may still use our websites, though some of their functionality may not be available to you.",
   "cookie-policy-update-frequency-title": "How Often Will We Update This Cookie Policy?",
   "cookie-policy-update-reason-text": "We may update this Cookie Policy from time to time in order to reflect any changes to the cookies and related technologies we use, or for other operational, legal or regulatory reasons.",
   "cookie-policy-version-notice-text": "Each time you use our websites, the current version of the Cookie Policy will apply. When you use our websites, you should check the date of this Cookie Policy (which appears at the top of this document) and review any changes since the last version.",
   "cookie-policy-further-info-title": "Where Can You Obtain Further Information?",
   "cookie-policy-contact-us-description-text": "For any questions or concerns regarding our Cookie Policy, you may contact us using the following details:",

   // My Performance (Staff)
   "loading-ellipsis-text": "Loading...",
   "failed-to-load-modules-error": "Failed to load modules",
   "failed-to-load-details-error": "Failed to load details",
   "my-assessments-title": "My assessments",
   "my-assessments-description-text":
      "Start by selecting an assessment to see its modules and performance insights.",
   "no-assessments-yet-title": "Looks like there are no assessments yet!",
   "no-assessments-yet-description-text":
      "When assessments have results, they will appear here for you to explore.",
   "modules-in-assessment-label": "Modules in this assessment:",
   "choose-module-to-see-results-text": "Choose a module to see results",
   "status-closed-label": "Closed",
   "select-module-alt-text": "Select module",
   "select-module-results-text": "Select a module from the list to display its results",
   "target-label": "Target",
   "action-plan-label": "Action plan",
   "assessment-preview-title": "Assessment preview",
   "no-data-for-assessment-text": "No data is currently available for this assessment",
   "my-upcoming-tasks-title": "My upcoming tasks",
   "my-improvement-over-time-title": "My improvement over time",
   "no-data-for-survey-text": "No data is currently available for this survey",
   "your-score-label": "Your score",
   "target-score-label": "Target score",
   "previous-label": "Previous",
   "next-label": "Next",

   // Task Management (Staff)
   "task-management-title": "Task management",
   "tasks-tab-label": "Tasks",
   "assigned-modules-title": "Assigned modules",
   "collapse-all-button": "Collapse all",
   "expand-all-button": "Expand all",
   "assigned-tasks-title": "Assigned Tasks",
   "board-tab-label": "Board",
   "timeline-tab-label": "Timeline",
   "no-available-modules-text": "No available modules for this assessment",
   "no-available-tasks-text": "No available tasks for this assessment",
   "go-alt-text": "Go",
   "view-alt-text": "View",
   "notes-alt-text": "Notes",
   "change-status-to-label": "Change status to:",
   "priority-low-label": "Low",
   "priority-medium-label": "Medium",
   "priority-high-label": "High",
   "priority-urgent-label": "Urgent",
   "show-less-link": "Show less",
   "monthly-toggle-label": "Monthly",
   "quarterly-toggle-label": "Quarterly",
   "week-prefix-text": "Week",
   "to-do-status": "To do",
   "tasks-column-header": "Tasks",
   "linked-questions-prefix-text": "Linked questions:",
   "assigned-status": "Assigned",
   "action-plan-dashboard-title": "Action plan dashboard",
   "action-plan-for-label": "Action plan for",

   // Role switcher (header profile menu) - an account can hold more than one
   // role and runs under one of them at a time.
   "role-vendor-label": "Vendor",
   "switch-role-label": "Switch role",
   "current-role-label": "Current role",
   "switch-role-error-description": "We couldn't switch your role, please try again.",
   "approver-role-added-to-existing-user-description":
      "This user already had an account, so no invitation email was sent. They sign in with their existing password and switch to the Approver role.",

   // Dual role (Expert + Approver on the same account)
   "expert-role-column": "Expert",
   "expert-role-enabled-success-title": "Expert role added",
   "expert-role-enabled-success-description": "This approver can now also work as an expert.",
   "expert-role-disabled-success-title": "Expert role removed",
   "expert-role-disabled-success-description": "This approver no longer has the expert role.",
   "expert-role-toggle-error-description": "We couldn't update the expert role, please try again.",
   "expert-role-not-found-description": "This approver no longer exists. The list has been refreshed.",
   "approver-role-column": "Approver",
   "approver-role-enabled-success-title": "Approver role added",
   "approver-role-enabled-success-description": "This expert can now also work as an approver.",
   "approver-role-disabled-success-title": "Approver role removed",
   "approver-role-disabled-success-description": "This expert no longer has the approver role.",
   "approver-role-toggle-error-description": "We couldn't update the approver role, please try again.",
   "approver-role-not-found-description": "This expert no longer exists. The list has been refreshed.",
   "expert-exists-redirect-title": "Already an Expert",
   "expert-exists-redirect-description":
      "This email already belongs to an Expert. We're taking you to the Experts list, where you can give them the Approver role instead.",

   // Linked assessment editing (admin)
   "linked-assessment-edit-notice":
      "This assessment is linked to another one, so only new rounds can be added. Every round you add here is added to the linked assessment too.",
   "start-date-in-past-validation": "Start date cannot be in the past.",
   "end-date-must-be-future-validation": "End date must be in the future.",
   "round-overlaps-another-round-validation": "This round overlaps with another round.",
   "view-all-notifications-button": "View all notifications",
   "notifications-page-title": "Notifications",
   "notifications-empty-title": "No notifications yet",
   "notifications-unread-empty-title": "No unread notifications",
   "notifications-empty-text": "You're all caught up. New notifications will appear here.",
   "guided-assessment-completed-prefix-text": "Your guided assessment",
   "guided-assessment-completed-suffix-text": "is completed.",
   "notification-title-org-signup": "New organization signup",
   "notification-title-expert-signup": "New expert signup",
   "notification-title-workspace-join-request": "Organization request to join workspace",
   "notification-title-workspace-approved": "Workspace request approved",
   "notification-title-workspace-rejected": "Workspace request rejected",
   "notification-title-guided-request": "Guided assessment request",
   "notification-title-guided-approved": "Guided assessment request approved",
   "notification-title-guided-rejected": "Guided assessment request rejected",
   "notification-title-guided-completed": "Guided-assessment completed",
   "notification-title-self-assigned": "New self-assessment assigned",
   "notification-title-self-unassigned": "Self-assessment unassigned",
   "notification-title-expert-assigned": "Assigned to guided-assessment",
   "notification-title-ticket-created": "New ticket created",
   "notification-title-ticket-updated": "Ticket is updated",
   "notification-title-submission-review": "Submission ready for review",
   "notification-title-submission-approved-by-approver": "Submission approved by approver",
   "notification-title-submission-rejected-by-approver": "Submission rejected by approver",
   "notification-title-module-assigned": "New module assigned",
   "notification-title-module-unassigned": "Module unassigned",
   "notification-title-submission-approved": "Submission approved",
   "notification-title-submission-rejected": "Submission rejected",
   "notification-title-submission-approval": "Submission ready for approval",
   "mark-as-read-label": "Mark as read",
   "notification-actions-label": "Notification actions"
};
